<template>
  <v-layout align-start v-resize="getDimensions">
    <v-flex>
      <v-overlay :absolute="true" :value="overlay">
        <v-progress-circular
          :rotate="-90"
          :size="200"
          :width="20"
          :value="valor"
          color="success"
        >
          {{ valor }} %
        </v-progress-circular>
      </v-overlay>
      

      <v-overlay :absolute="true" :value="overlay2">
        <v-progress-circular
          :rotate="-90"
          :size="150"
          :width="20"
          :value="((areaProcesadaCount*100)/(areasTotales===0?1:areasTotales))"
          color="success"
        >
          
        </v-progress-circular>
        <div class="text-center mt-4">
          <span>Procesando el área {{ areaProcesadaCount }} de {{ areasTotales }}: {{
            areaProcesada
          }} </span>
        </div>
      </v-overlay>

     


      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll>
          <v-toolbar-title class="font-weight-black primary--text"
            >Detalle del Presupuesto de Nóminas</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                :disabled="!presupSelect"
                color="primary"
                @click="
                  boxEliminarPersonaPresupuesto === true
                    ? mostrarDialogEliminacionPersona()
                    : (boxEliminarPersonaPresupuesto = true)
                "
                v-bind="attrs"
                v-on="on"
                v-role="['ADM', 'NOM']"
              >
                <v-icon dark>
                  {{
                    boxEliminarPersonaPresupuesto === true ? "delete" : "rule"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              boxEliminarPersonaPresupuesto === true
                ? "Eliminar Seleccionados"
                : "Mostrar cuadro de eliminación"
            }}</span>
          </v-tooltip>

          <v-menu v-if="false" :rounded="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                color="primary"
                v-bind="attrs"
                v-on="on"
                dark
                :disabled="!presupSelect"
                v-role="['ADM', 'NOM']"
              >
                <v-icon dark>fa-solid fa-money-bill-1-wave</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="mostrarPersonaIncremento">
                <v-list-item-title
                  >Modificación masiva de Sueldos</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click="dialogSincronizarSueldos = true">
                <v-list-item-title
                  >Sincronizar Sueldos con Novus</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu :rounded="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                color="primary"
                v-bind="attrs"
                :loading="load"
                v-on="on"
                :disabled="!presupSelect"
                dark
                v-role="['ADM', 'NOM']"
              >
                <v-icon dark> fa-solid fa-file-excel </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="descargarReporte">
                <v-list-item-title>Exportar Presupuesto</v-list-item-title>
              </v-list-item>
              <v-list-item @click="descargarReportePresupRealEstim">
                <v-list-item-title 
                  >Exportar Presupuesto Real Estimado</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click="descargarReporteAnalisis">
                <v-list-item-title
                  >Exportar Clasificación - Análisis de
                  Variación</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                @click="
                  descargarRepContable(
                    'TG',
                    'S',
                    'REPORTE GASTOS LABORALES - GASTO'
                  )
                "
              >
                <v-list-item-title
                  >REPORTE GASTOS LABORALES - GASTO</v-list-item-title
                >
              </v-list-item>

              <v-list-item
                @click="
                  descargarRepContablePasivo(
                    'REPORTE GASTOS LABORALES - PASIVO'
                  )
                "
              >
                <v-list-item-title
                  >REPORTE GASTOS LABORALES - PASIVO</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                @click="
                  descargarRepContable(
                    'OGA',
                    'N',
                    'REPORTE OTROS GASTOS LABORALES - GASTO'
                  )
                "
              >
                <v-list-item-title
                  >REPORTE OTROS GASTOS LABORALES - GASTO</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click="dialogExcel = true">
                <v-list-item-title>Anexo 2</v-list-item-title>
              </v-list-item>
              <v-list-item @click="descargarReporteFiniquitos()">
                <v-list-item-title
                  >Exportar Reporte de Quinquenios</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                @click="
                  descargarReporteDetallePresupuestoCuentaCategoriaSubcategoria()
                "
              >
                <v-list-item-title
                  >Exportar Reporte Cuenta Subcategoria</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu :rounded="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                color="primary"
                v-bind="attrs"
                :loading="load"
                v-on="on"
                :disabled="!presupSelect"
                dark
                v-role="['PRE']"
              >
                <v-icon dark> fa-solid fa-file-excel </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="descargarReporteOtrosGastos()">
                <v-list-item-title>Exportar Presupuesto</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarCarga"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark> fa-solid fa-cloud-arrow-up</v-icon>
              </v-btn>
            </template>
            <span>Carga masiva de datos</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarDatosCargados"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark> fa-solid fa-eye </v-icon>
              </v-btn>
            </template>
            <span>Ver Datos Cargados</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarCuadroGeneracionPresupuesto"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect || id_version_presupuesto === 2 || id_version_presupuesto === 12 || id_version_presupuesto === 13 
                || id_version_presupuesto === 15 || id_version_presupuesto === 16" 
              >
                <v-icon dark> control_point_duplicate </v-icon>
              </v-btn>
            </template>
            <span>Generación masiva de presupuesto de nóminas</span>
          </v-tooltip>
        </v-app-bar>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <v-autocomplete
                dense
                outlined
                ref="id_presupuesto"
                v-model="id_presupuesto"
                @change="selectVersionPresupuesto"
                :items="presupuestos"
                :rules="[$rules.requerido]"
                :error-messages="errorMessages"
                item-text="descripcion"
                item-value="id"
                label="Presupuesto"
                required
              >
                <template v-slot:no-data>
                  No hay información disponible
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" v-show="!$esNulo(id_presupuesto)">
              <v-autocomplete
                dense
                outlined
                ref="id_version_presupuesto"
                v-model="id_version_presupuesto"
                @change="listar(), mostrarTipoVersion()"
                :items="versionPresupuestos"
                :rules="[$rules.requerido]"
                :error-messages="errorMessages"
                item-text="descripcion"
                item-value="id"
                label="Versión de Presupuesto"
                required
              >
                <template v-slot:no-data>
                  <div>
                    <v-btn
                      outlined
                      tile
                      color="primary"
                      @click="mostrarVersionPresupuesto('add')"
                    >
                      <v-icon left> add </v-icon>
                      Agregar Versión
                    </v-btn>
                  </div>
                </template>

                <template v-slot:item="{ item }">
                  <v-list-item-avatar
                    color="indigo"
                    class="text-h5 font-weight-light white--text"
                  >
                    {{ item.tipo.charAt(0) }}
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.descripcion }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.tipo }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      class="primary--text font-weight-bold"
                    >
                      {{ item.estado }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon>user</v-icon>
                  </v-list-item-action>
                </template>

                <template v-slot:append-outer>
                  <v-btn
                    v-show="!$esNulo(id_version_presupuesto)"
                    class="mx-2"
                    fab
                    dark
                    x-small
                    @click="mostrarVersionPresupuesto('edit')"
                    color="success"
                  >
                    <v-icon dark> edit </v-icon>
                  </v-btn>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" v-show="!$esNulo(id_presupuesto)">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Búsqueda"
                hide-details
              ></v-text-field>
            </v-col>
           
            <v-col cols="12" sm="3" md="3">
              
              <v-text-field
              v-show="presupSelect"
                                  outlined
                                  reverse
                                  dense
                                  
                                  append-icon="save"
                                  @click:append="cambiarSalario()"
                                  v-model="salario_minimo"
                                  
                                  
                                 
                                  label="Salario Mínimo"
                                  required
                                ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-sheet
          class="overflow-y-auto"
          :max-height="height - 200"
          v-if="mostrarTabla"
        >
          <v-data-table
            dense
            fixed-header
            mobile-breakpoint="0"
            :height="height - 300"
            :page.sync="page"
            :items="presupuesto_lineas"
            v-model="selectPersonaPresup"
            :headers="headers"
            :search="search"
            item-key="id_persona"
            :show-select="boxEliminarPersonaPresupuesto"
            sort-by="codigo"
            class="elevation-1"
            :loading="loadTable"
            loading-text="Cargando... Espere por favor"
            show-group-by
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Filas por página',
              'group-text': 'Agrupar',
              'items-per-page-options': [-1, 50, 100, 150],
              'all-rows': 'Todos',
            }"
          >
            <template v-slot:[`item.opciones`]="{ item }">
              <v-btn x-small text dark color="primary" @click="editItem(item)">
                <v-icon x-small>edit</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'A'">
                <v-btn
                  color="success"
                  x-small
                  text
                  dark
                  @click="desactivar(item)"
                >
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn color="error" x-small text dark @click="activar(item)">
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:[`item.mes`]="{ item }">
              <div>
                {{ item.mes === null ? "" : enteroaMeses(item.mes, true) }}
              </div>
            </template>
            <template v-slot:[`item.total`]="{ item }">
              <div class="font-weight-bold">
                {{ (item.total = formatoNumero(item.total, 2)) }}
              </div>
            </template>
            <template v-slot:[`item.nombre`]="{ item }">
              <div class="primary--text" @click="editItem(item)">
                {{ item.nombre }}
              </div>
            </template>

            <template v-slot:[`item.fecha_ingreso`]="{ item }">
              <div>
                {{
                  item.fecha_ingreso === null
                    ? ""
                    : formatoFechaSpanish(item.fecha_ingreso)
                }}
              </div>
            </template>
            <template v-slot:[`item.fecha_salida`]="{ item }">
              <div>
                {{
                  item.fecha_salida === null
                    ? ""
                    : formatoFechaSpanish(item.fecha_salida)
                }}
              </div>
            </template>

            <template v-slot:top>
              <v-dialog v-model="dialogPresupuesto" persistent>
                <v-card ref="formPresupuesto" class="overflow-hidden">
                  <v-app-bar color="white" elevate-on-scroll>
                    <v-toolbar-title class="font-weight-black primary--text"
                      >{{ formTitlePresupuesto }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          color="primary"
                          @click="
                            boxEliminarPresupuesto === true
                              ? mostrarDialogEliminacion()
                              : (boxEliminarPresupuesto = true)
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark>
                            {{
                              boxEliminarPresupuesto === true
                                ? "delete"
                                : "rule"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        boxEliminarPresupuesto === true
                          ? "Eliminar Seleccionados"
                          : "Mostrar cuadro de eliminación"
                      }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          color="primary"
                          @click="closeDetallePresup"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> close </v-icon>
                        </v-btn>
                      </template>
                      <span>Volver/Cancelar</span>
                    </v-tooltip>
                  </v-app-bar>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="3" md="3">
                        <v-autocomplete
                          dense
                          outlined
                          v-model="searchCuentaPresupValue"
                          :items="personaPresupuesto"
                          append-icon="search"
                          label="Cuenta Contable"
                          item-text="cuenta_contable"
                          item-value="cuenta_contable"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        <v-autocomplete
                          dense
                          outlined
                          v-model="searchCencoPresupValue"
                          :items="personaPresupuesto"
                          append-icon="search"
                          label="Cenco"
                          item-text="centro_costo"
                          item-value="centro_costo"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        <v-autocomplete
                          dense
                          outlined
                          v-model="searchMesValue"
                          :items="meses"
                          append-icon="search"
                          label="Mes"
                          item-text="descripcion"
                          item-value="id"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        <v-autocomplete
                          dense
                          outlined
                          v-model="searchSubcategoriaPresupValue"
                          :items="personaPresupuesto"
                          append-icon="search"
                          label="Subcategoria"
                          item-text="subcategoria"
                          item-value="subcategoria"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-sheet class="overflow-y-auto" :max-height="height - 170">
                    <v-data-table
                      dense
                      fixed-header
                      :height="height - 310"
                      :page.sync="page"
                      :items="personaPresupuesto"
                      v-model="selectDatosPresup"
                      :headers="headersPresupuesto"
                      :items-per-page="itemsPerPage"
                      item-key="id"
                      :loading="loadTable"
                      :show-select="boxEliminarPresupuesto"
                      sort-by="mes"
                      class="elevation-1"
                      show-group-by
                      group-by="subcategoria"
                      :header-props="{
                        'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                      }"
                      :footer-props="{
                        showFirstLastPage: true,
                        'items-per-page-text': 'Filas por página',
                        'group-text': 'Agrupar',
                        'items-per-page-options': [20, 30, 40, 50, -1],
                        'all-rows': 'Todos',
                      }"
                    >
                      <template v-slot:[`item.fecha_ingreso`]="{ item }">
                        <div>
                          {{
                            item.fecha_ingreso === null
                              ? ""
                              : formatoFechaSpanish(item.fecha_ingreso)
                          }}
                        </div>
                      </template>
                      <template v-slot:[`item.fecha_salida`]="{ item }">
                        <div>
                          {{
                            item.fecha_salida === null
                              ? ""
                              : formatoFechaSpanish(item.fecha_salida)
                          }}
                        </div>
                      </template>

                      <template v-slot:[`item.mes`]="{ item }">
                        <div>
                          {{
                            enteroaMeses(item.mes, true) + "(" + item.mes + ")"
                          }}
                        </div>
                      </template>
                      <template v-slot:[`item.monto`]="{ item }">
                        <div>
                          {{ formatoNumero(item.monto, 2) }}
                        </div>
                      </template>
                      <template v-slot:[`item.monto_total`]="{ item }">
                        <div>
                          {{ formatoNumero(item.monto_total, 2) }}
                        </div>
                      </template>

                      <template v-slot:no-data>
                        No hay datos de presupuesto disponibles
                      </template>
                    </v-data-table>
                  </v-sheet>
                </v-card>
              </v-dialog>

              <v-dialog
                v-model="dialogTotalDescuentos"
                persistent
                max-width="290"
              >
                <v-card>
                  <v-card-title class="headline">¿Está seguro?</v-card-title>
                  <v-card-text
                    >Esta acción calculará el total de descuentos para los
                    empleados seleccionados, en base a la configuración actual a
                    partir de {{ enteroaMeses(mesInicioCalculo, false) }},
                    ¿Desea continuar?</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogTotalDescuentos = false"
                      >Cancelar</v-btn
                    >
                    <v-btn color="primary" text @click="aaaaa()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogCargaMasiva" persistent max-width="350">
                <v-card>
                  <v-card-title class="headline">¿Está seguro?</v-card-title>
                  <v-card-text>
                    <p>
                      Esta acción calculará el total ganado, el total de
                      descuentos, aguinaldos y primas para los empleados
                      seleccionados, en base a la configuración actual a partir
                      de
                      {{ enteroaMeses(mesInicioCalculo, false) }}, ¿Desea
                      continuar?
                    </p>

                    <v-text-field
                      reverse
                      outlined
                      dense
                      ref="porcentaje_sueldo"
                      v-model="porcentaje_sueldo"
                      prefix=" %"
                      :rules="[$rules.requerido, $rules.numero]"
                      :error-messages="errorMessages"
                      label="Porcentaje del Sueldo"
                      required
                    ></v-text-field>
                    <v-text-field
                      reverse
                      outlined
                      dense
                      ref="porcentaje_comision"
                      prefix=" %"
                      v-model="porcentaje_comision"
                      :rules="[$rules.requerido, $rules.numero]"
                      :error-messages="errorMessages"
                      label="Porcentaje de la Comisión"
                      required
                    ></v-text-field>
                    <v-text-field
                      reverse
                      outlined
                      dense
                      ref="porcentaje_vacacion"
                      prefix=" %"
                      v-model="porcentaje_vacacion"
                      :rules="[$rules.requerido, $rules.numero]"
                      :error-messages="errorMessages"
                      label="Porcentaje de Vacación"
                      required
                    ></v-text-field>
                    <v-checkbox
                      v-model="restar_vacacion_pasada"
                      label="Reducir Vacaciones Estimadas y Proyectadas"
                    ></v-checkbox>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogCargaMasiva = false"
                      >Cancelar</v-btn
                    >
                    <v-btn color="primary" text @click="generarCargaMasiva()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="dialogCargaMasivaReal"
                persistent
                max-width="350"
              >
                <v-card>
                  <v-card-title class="headline">¿Está seguro?</v-card-title>
                  <v-card-text>
                    <p>
                      Esta acción calculará el total ganado, el total de
                      descuentos, aguinaldos y primas para los empleados de la
                      gestión seleccionada, en base a la configuración actual a
                      partir de
                      {{ enteroaMeses(mesInicioCalculo, false) }}, ¿Desea
                      continuar?
                    </p>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogCargaMasivaReal = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="primary"
                      text
                      @click="generarCargaMasivaReal()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogEliminacion" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">¿Está seguro?</v-card-title>
                  <v-card-text>
                    <p>
                      Esta acción eliminará todos los cálculos seleccionados
                      asociados a {{ nombreCompleto }}, del presupuesto actual.
                      ¿Desea continuar?
                    </p>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogEliminacion = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="primary"
                      text
                      @click="eliminarLineasPresupuesto()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="dialogEliminacionPersona"
                persistent
                max-width="290"
              >
                <v-card>
                  <v-card-title class="headline">¿Está seguro?</v-card-title>
                  <v-card-text>
                    <p>
                      Esta acción eliminará todos los cálculos seleccionados
                      asociados a las personas seleccionadas, del presupuesto
                      actual. ¿Desea continuar?
                    </p>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelarEliminacionPersona()"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="primary"
                      text
                      :loading="loadBorrar"
                      @click="eliminarPersonasPresupuesto()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>

            <template v-slot:no-data> No hay datos disponibles </template>
          </v-data-table>
        </v-sheet>
      </v-card>

      <v-dialog v-model="dialogUpload" max-width="800px" persistent >
        <v-card>
          <v-card-title class="white--text" style="background-color: #2e7d32;">
            <span class="headline">
              <v-icon dark class="mr-2">fa-solid fa-file-excel</v-icon>
              Carga Masiva de {{ tipoCargaMasiva === 'subcategoria' ? 'Comisiones/Premios' : 'Vacaciones' }}
            </span>
          </v-card-title>
          
          <v-stepper v-model="stepUpload" alt-labels>
            <v-stepper-header>
              <v-stepper-step :complete="stepUpload > 1" step="1">Instrucciones</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="stepUpload > 2" step="2">Cargar Archivo</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3">Resultados</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <!-- Step 1: Instrucciones -->
              <v-stepper-content step="1">
                <v-card flat>
                  <v-card-text>
                    <v-radio-group v-model="tipoCargaMasiva" row>
                      <v-radio label="Subcategorías (Comisiones/Premios)" value="subcategoria"></v-radio>
                      <v-radio label="Vacaciones Adelantadas" value="vacaciones"></v-radio>
                    </v-radio-group>

                    <v-alert type="info" text color="info">
                      <div class="text-subtitle-1 font-weight-bold">Formato del archivo Excel</div>
                      El archivo debe contener las siguientes columnas en orden:
                    </v-alert>

                    <v-list dense v-if="tipoCargaMasiva === 'subcategoria'">
                      <v-list-item>
                        <v-list-item-icon><v-icon color="success">mdi-numeric-1-box</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">Código de Empleado</v-list-item-title>
                          <v-list-item-subtitle>Código asignado en el sistema (obligatorio)</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-icon><v-icon color="success">mdi-calendar-month</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">Mes</v-list-item-title>
                          <v-list-item-subtitle>Mes de la comisión/premio (1-12)</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-icon><v-icon color="success">mdi-cash</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">Monto</v-list-item-title>
                          <v-list-item-subtitle>Monto en bolivianos (obligatorio)</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    
                    <v-list dense v-if="tipoCargaMasiva === 'vacaciones'">
                      <v-list-item>
                        <v-list-item-icon><v-icon color="success">mdi-numeric-1-box</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">Código de Empleado</v-list-item-title>
                          <v-list-item-subtitle>Código asignado en el sistema (obligatorio)</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-icon><v-icon color="success">mdi-calendar-month</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">Mes</v-list-item-title>
                          <v-list-item-subtitle>Mes en que se adelantó (1-12)</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-icon><v-icon color="success">mdi-calendar</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">Año</v-list-item-title>
                          <v-list-item-subtitle>Año correspondiente (obligatorio)</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-icon><v-icon color="success">mdi-island</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">Días</v-list-item-title>
                          <v-list-item-subtitle>Cantidad de días tomados (obligatorio)</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-alert type="warning" text color="warning" class="mt-4">
                      <strong>Importante:</strong>
                      <ul>
                        <li>Las filas con códigos inexistentes o errores se omitirán del guardado.</li>
                        <li>Asegúrese de cargar las columnas en el orden exacto.</li>
                      </ul>
                    </v-alert>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="success" @click="closeUpload">Cancelar</v-btn>
                    <v-btn color="success" @click="stepUpload = 2">Siguiente</v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>

              <!-- Step 2: Cargar Archivo -->
              <v-stepper-content step="2">
                <v-card flat>
                  <v-card-text class="text-center">
                    <v-autocomplete
                      v-if="tipoCargaMasiva === 'subcategoria'"
                      dense
                      outlined
                      ref="id_subcategoria"
                      v-model="id_subcategoria"
                      :items="subcategorias"
                      :rules="[$rules.requerido]"
                      :error-messages="errorMessages"
                      item-text="descripcion"
                      item-value="id"
                      label="Seleccione la Subcategoría (Destino)"
                      required
                    ></v-autocomplete>

                    <br/>
                    <v-btn outlined color="success" class="mb-6" @click="descargarPlantilla">
                      <v-icon left>fa-solid fa-download</v-icon> Descargar Plantilla
                    </v-btn>
                    <br/><br/>
                    <v-file-input
                      dense
                      outlined
                      id="file"
                      ref="file"
                      v-model="file"
                      @change="archivoCambiado"
                      show-size
                      chips
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      prepend-icon="cancel_presentation"
                      label="Seleccionar archivo Excel"
                    ></v-file-input>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="black" :loading="load" @click="stepUpload = 1">Atrás</v-btn>
                    <v-btn color="success" :loading="load" @click="guardarExcel">Importar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>

              <!-- Step 3: Resultados -->
              <v-stepper-content step="3">
                <v-card flat>
                  <v-card-text>
                    <div v-if="!mostrarErrores" class="text-center">
                      <v-icon size="64" color="success">check_circle_outline</v-icon>
                      <h3 class="mt-4 success--text">¡Carga exitosa!</h3>
                      <p>Los datos fueron importados correctamente.</p>
                    </div>
                    <div v-else>
                      <v-alert type="error" text>Se encontraron errores durante la importación:</v-alert>
                      <v-textarea
                        outlined
                        dense
                        ref="error"
                        v-model="error"
                        :readonly="true"
                        rows="8"
                      ></v-textarea>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="closeUpload">Finalizar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogVerDatos" max-width="900px">
        <v-card>
          <v-card-title class="white--text" style="background-color: #2e7d32;">
            <span class="headline">
              <v-icon dark class="mr-2">mdi-table</v-icon>
              Datos Cargados - {{ tipoCargaMasiva === 'subcategoria' ? 'Comisiones/Premios' : 'Vacaciones' }}
            </span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogVerDatos = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pt-4">
            <v-radio-group v-model="tipoCargaMasiva" row @change="cargarDatosMasivos">
              <v-radio label="Subcategorías (Comisiones/Premios)" value="subcategoria"></v-radio>
              <v-radio label="Vacaciones Adelantadas" value="vacaciones"></v-radio>
            </v-radio-group>
            
            <v-data-table
              dense
              fixed-header
              height="400"
              :headers="headersDatosCargados"
              :items="datosCargadosFiltrados"
              :loading="cargandoDatos"
              class="elevation-1"
              :header-props="{
                'sort-icon': 'fa-solid fa-arrow-down-wide-short',
              }"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-text': 'Filas por página',
                'group-text': 'Agrupar',
                'items-per-page-options': [20, 30, 40, 50, -1],
                'all-rows': 'Todos',
              }"
            >
              <template v-slot:header="{}">
                <thead class="v-data-table-header">
                  <tr>
                    <th colspan="5">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            dense
                            hide-details
                            outlined
                            v-model="searchNombreCargado"
                            append-icon="search"
                            label="Buscar por Nombre"
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            dense
                            hide-details
                            outlined
                            v-model="searchCargoCargado"
                            append-icon="search"
                            label="Buscar por Cargo"
                            clearable
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </th>
                  </tr>
                </thead>
              </template>
              
              <template v-slot:[`item.monto`]="{ item }">
                {{ tipoCargaMasiva === 'vacaciones' ? item.monto + ' Días' : 'Bs. ' + parseFloat(item.monto).toFixed(2) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>


      <v-dialog v-model="dialogTablaVista" persistent max-width="100%">
        <v-card>
          <v-card-title class="headline">Presupuesto por Año</v-card-title>
          <v-card-text>
            <v-data-table
              dense
              :headers="headersVista"
              :items="vistas"
              :items-per-page="2"
              :loading="loadTable"
              :search="search"
              sort-by="producto"
              class="elevation-1"
              show-group-by
              :header-props="{
                'sort-icon': 'fa-solid fa-arrow-down-wide-short',
              }"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-text': 'Filas por página',
                'group-text': 'Agrupar',
                'items-per-page-options': [20, 30, 40, 50, -1],
              }"
            >
              <template v-slot:[`item.opciones`]="{ item }">
                <v-btn
                  x-small
                  text
                  dark
                  color="primary"
                  @click="editItem(item)"
                >
                  <v-icon x-small>edit</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data> No hay datos disponibless </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogTablaVista = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogPersonaIncremento" max-width="100%">
        <v-card ref="formPersona" class="overflow-hidden">
          <v-app-bar color="white" elevate-on-scroll>
            <v-toolbar-title class="font-weight-black primary--text"
              >Modificación de Salarios</v-toolbar-title
            >
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="mostrarBusqueda"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>
                    {{ mostrarBusquedas ? "search_off" : "search" }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{
                mostrarBusquedas
                  ? "Ocultar filtros de búsqueda"
                  : "Mostrar filtros de búsqueda"
              }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  color="primary"
                  @click="mostrarPorcentajeInc"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> percent </v-icon>
                </v-btn>
              </template>
              <span>Modificación masiva de salarios</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  color="primary"
                  @click="closeIncremento"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Volver/Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-row v-if="mostrarBusquedas">
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  outlined
                  dense
                  class="text-xs-center"
                  v-model="searchPersIncNombre"
                  append-icon="search"
                  label="Nombre"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  outlined
                  dense
                  class="text-xs-center"
                  v-model="searchPersIncCenco"
                  append-icon="search"
                  label="Cenco"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  outlined
                  dense
                  class="text-xs-center"
                  v-model="searchPersIncCargo"
                  append-icon="search"
                  label="Cargo"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-sheet class="overflow-y-auto" :max-height="height">
            <v-data-table
              dense
              fixed-header
              :height="height"
              :page.sync="page"
              :items="personasIncremento"
              :loading="loadTable"
              v-model="selectPersonasIncremento"
              :headers="headersPersonaIncremento"
              :items-per-page="itemsPerPage"
              item-key="id"
              show-select
              sort-by="mes"
              class="elevation-1"
              :header-props="{
                'sort-icon': 'fa-solid fa-arrow-down-wide-short',
              }"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-text': 'Filas por página',
                'group-text': 'Agrupar',
                'items-per-page-options': [-1, 50, 100, 200],
                'all-rows': 'Todos',
              }"
            >
              <template v-slot:[`item.fecha_ingreso`]="{ item }">
                <div>
                  {{
                    item.fecha_ingreso === null
                      ? ""
                      : formatoFechaSpanish(item.fecha_ingreso)
                  }}
                </div>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="listarPersona"> Reset </v-btn>
              </template>
              <template v-slot:[`item.salario_ref`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.salario_ref"
                  large
                  @save="guardarSueldo(item)"
                  @cancel="cancelarSueldo"
                  save-text="Guardar"
                  cancel-text="Cancelar"
                >
                  <div>
                    {{ (item.salario_ref = redondear(item.salario_ref, 2)) }}
                    <v-icon x-small>border_color </v-icon>
                  </div>
                  <template v-slot:input>
                    <div class="mt-4 text-h6">Modificar Salario</div>
                    <v-text-field
                      outlined
                      dense
                      reverse
                      v-model="item.salario_ref"
                      :rules="[$rules.numero]"
                      label="Salario"
                      counter
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>

              <template v-slot:[`item.salario_novus`]="{ item }">
                <div>
                  {{ (item.salario_novus = redondear(item.salario_novus, 2)) }}
                </div>
              </template>
              <template v-slot:[`item.variacion`]="{ item }">
                <div v-if="item.variacion > 0" class="success--text">
                  {{ (item.variacion = redondear(item.variacion, 2)) }}
                  %
                </div>
                <div v-else>
                  <div v-if="item.variacion < 0" class="error--text">
                    {{ (item.variacion = redondear(item.variacion, 2)) }}
                    %
                  </div>
                  <div v-else>
                    {{ (item.variacion = redondear(item.variacion, 2)) }}
                    %
                  </div>
                </div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSincronizarSueldos" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción revertirá todos los cambios que realizó en los salarios
            del módulo. ¿Desea continuar?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogSincronizarSueldos = false"
              >Cancelar</v-btn
            >
            <v-btn color="primary" text @click="sincronizarSalarios()"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogExcel" persistent max-width="500">
        <v-card>
          <v-card-title>Generación de Reportes</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-autocomplete
                  outlined
                  dense
                  ref="variableCalculo"
                  v-model="variableCalculo"
                  :items="variablesList"
                  :rules="[$rules.requerido]"
                  :error-messages="errorMessages"
                  label="Variable de Cálculo"
                  item-text="descripcion"
                  item-value="id"
                  required
                ></v-autocomplete>

                <v-text-field
                  outlined
                  dense
                  v-model="porcentaje"
                  :rules="[$rules.requerido]"
                  label="Porcentaje de variación"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogExcel = false">Cancelar</v-btn>
            <v-btn
              color="primary"
              text
              @click="descargarReporteAnexoB()"
              :loading="load"
              >Generar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogVersionPresupuesto"
        persistent
        :fullscreen="isMobile"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="formVersionPresupuesto" id="lateral">
              <v-app-bar color="white" elevate-on-scroll flat>
                <div class="headline">Versión de Presupuesto</div>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="guardarVersionPresupuesto"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon> fa-solid fa-save </v-icon>
                    </v-btn>
                  </template>
                  <span>Guardar Versión</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeVersionPresupuesto"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
              </v-app-bar>

              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        outlined
                        dense
                        type="text"
                        ref="codigoVersionPresupuesto"
                        v-model="codigoVersionPresupuesto"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessages"
                        label="Código"
                      >
                      </v-text-field>

                      <v-text-field
                        outlined
                        dense
                        type="text"
                        ref="descripcionVersionPresupuesto"
                        v-model="descripcionVersionPresupuesto"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessages"
                        label="Descripción"
                      >
                      </v-text-field>

                      <v-text-field
                        outlined
                        dense
                        type="number"
                        ref="salarioMinimoVersionPresupuesto"
                        v-model.number="salarioMinimoVersionPresupuesto"
                        :error-messages="errorMessages"
                        label="Salario Mínimo Nacional (Bs)"
                      >
                      </v-text-field>

                      <v-autocomplete
                        dense
                        outlined
                        ref="mes_real_hasta"
                        v-model="mes_real_hasta"
                        @change="calcularMesesRealesPresup"
                        :items="mesesVersion"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessages"
                        item-text="descripcion"
                        item-value="id"
                        label="Calcular datos reales hasta el mes:"
                        required
                      >
                        <template v-slot:no-data>
                          No hay información disponible
                        </template>
                      </v-autocomplete>

                      <v-system-bar color="white">
                        <div class="text-center font-weight-bold">
                          {{ calculoReal }}
                        </div>
                      </v-system-bar>
                      <v-system-bar color="white">
                        <div class="text-center font-weight-bold">
                          {{ calculoPresupuesto }}
                        </div>
                      </v-system-bar>

                      <v-switch
                        v-model="es_oficial"
                        @change="
                          es_oficial
                            ? mostrarAdvertenciaOficial()
                            : (es_oficial = es_oficial)
                        "
                        inset
                        :label="
                          (es_oficial
                            ? 'Presupuesto oficial de la gestión '
                            : 'Presupuesto no oficial de la gestión ') +
                          this.gestion
                        "
                      ></v-switch>
                      <v-switch
                        v-show="!editVersion"
                        v-model="otraVersion"
                        @change="id_version_basado = ''"
                        inset
                        :label="
                          otraVersion
                            ? 'Basar presupuesto en otra versión '
                            : 'Crear un presupuesto nuevo'
                        "
                      ></v-switch>
                      <v-autocomplete
                        v-show="otraVersion"
                        dense
                        outlined
                        ref="id_version_basado"
                        v-model="id_version_basado"
                        :items="versionPresupuestos"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessages"
                        item-text="descripcion"
                        item-value="id"
                        label="Versión de Presupuesto"
                        required
                      >
                        <template v-slot:no-data>
                          <div>No hay versiones disponibles.</div>
                        </template>

                        <template v-slot:item="{ item }">
                          <v-list-item-avatar
                            color="indigo"
                            class="text-h5 font-weight-light white--text"
                          >
                            {{ item.tipo.charAt(0) }}
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              item.descripcion
                            }}</v-list-item-title>
                            <v-list-item-subtitle>
                              {{ item.tipo }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                              class="primary--text font-weight-bold"
                            >
                              {{ item.estado }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon>user</v-icon>
                          </v-list-item-action>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-sheet>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog v-model="dialogOficial" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h5"> ¿Está seguro? </v-card-title>
          <v-card-text
            >Esta acción definirá a esta versión como la versión oficial y se
            generarán los reportes y hará el seguimiento en base a
            esta.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="
                dialogOficial = false;
                es_oficial = false;
              "
            >
              Cancelar
            </v-btn>
            <v-btn color="green darken-1" text @click="dialogOficial = false">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog dense persistent v-model="dialogUniformes" max-width="800px">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <span class="font-weight-black primary--text">{{
              "Lista de Uniformes"
            }}</span>

          </v-app-bar>

          <v-card-text>
            <v-sheet class="overflow-y-auto" :max-height="height - 120">
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  dense
                  outlined
                  class="text-xs-center"
                  v-model="filtroUniformes"
                  append-icon="search"
                  label="Buscar"
                  hide-details
                ></v-text-field>
              </v-col>

              <v-data-table
                dense
                fixed-header
                :height="height - 380"
                :page.sync="page"
                :items="uniformeList"
                ref="selectUniformes"
                v-model="selectUniformes"
                :loading="loadTable"
                :headers="headersUniforme"
                :items-per-page="itemsPerPage"
                item-key="id"
                show-select
                sort-by="mes"
                class="elevation-1"
                :search="filtroUniformes"
                :header-props="{
                  'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                }"
                :footer-props="{
                  showFirstLastPage: true,
                  'items-per-page-text': 'Filas por página',
                  'group-text': 'Agrupar',
                  'items-per-page-options': [-1, 20, 30, 40, 50, -1],
                  'all-rows': 'Todos',
                }"
              >
                <template v-slot:[`item.genero`]="{ item }">
                  <v-chip
                    v-for="(gen, index) in JSON.parse(item.genero)"
                    class="ma-2"
                    :color="gen == 'Masculino' ? 'accent' : 'femm'"
                    text-color="white"
                    x-small
                    :key="index"
                  >
                    {{ gen }}
                  </v-chip>
                </template>
                <template v-slot:no-data>
                  No hay datos de personas disponibles
                </template>
              </v-data-table>
            </v-sheet>
          </v-card-text>

          <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogUniformes = false"
                      >Cancelar</v-btn
                    >
                    <v-btn color="primary" text @click="generarUniformes()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" :fullscreen="true">
        <v-card ref="formPersona" class="overflow-hidden">
          <v-app-bar color="white" elevate-on-scroll>
            <span class="font-weight-black primary--text body-1"
              >Cálculo del Presupuesto</span
            >
            <v-spacer></v-spacer>
            <v-autocomplete
              dense
              outlined
              ref="mesInicioCalculo"
              v-model="mesInicioCalculo"
              :items="meses"
              :rules="[$rules.requerido]"
              :error-messages="errorMessages"
              item-text="descripcion"
              item-value="id"
              hint="Mes de inicio del cálculo"
              label="Mes de inicio del cálculo"
              hide-details
              required
            ></v-autocomplete>
            <v-spacer></v-spacer>

            <v-autocomplete
              dense
              outlined
              v-model="id_planilla"
              :items="planillas"
              item-text="codigo"
              item-value="id"
              label="Planilla Base"
              clearable
              hide-details
              @change="listarPersona"
            ></v-autocomplete>
            <v-tooltip bottom v-if="id_planilla">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="$refs.detallesDialog.open(id_planilla)" color="primary" v-bind="attrs" v-on="on" class="ml-2">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Editar Planilla</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="mostrarBusqueda"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>
                    {{ mostrarBusquedas ? "search_off" : "search" }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{
                mostrarBusquedas
                  ? "Ocultar filtros de búsqueda"
                  : "Mostrar filtros de búsqueda"
              }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  :loading="load"
                  @click="exportarExcelPer"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  v-role="['ADM', 'NOM']"
                >
                  <v-icon dark> fa-solid fa-file-excel </v-icon>
                </v-btn>
              </template>
              <span>Exportar lista a Excel</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="mostrarListaUniforme"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!presupSelect"
                  v-role="['ADM', 'NOM', 'PRE']"
                >
                  <v-icon dark> fa-solid fa-shirt </v-icon>
                </v-btn>
              </template>
              <span>Calcular Dotación de Uniformes</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="generarOtrosGastos"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!presupSelect"
                  v-role="['ADM', 'NOM', 'PRE']"
                >
                  <v-icon dark> fa-solid fa-money-check-dollar </v-icon>
                </v-btn>
              </template>
              <span>Calcular Otros Gastos de Personal</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  color="primary"
                  @click="generarSubsidio"
                  v-bind="attrs"
                  v-on="on"
                  v-role="['ADM', 'NOM', 'PRE']"
                >
                  <v-icon dark> pregnant_woman </v-icon>
                </v-btn>
              </template>
              <span>Calcular Subsidios</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  color="primary"
                  @click="mostrarDialogCargaMasiva"
                  v-bind="attrs"
                  v-on="on"
                  v-role="['ADM', 'NOM']"
                >
                  <v-icon dark> iso </v-icon>
                </v-btn>
              </template>
              <span>Calcular Remuneraciones y Descuentos</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  color="primary"
                  @click="close"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Volver/Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-sheet class="overflow-y-auto" :max-height="height">
            <v-system-bar color="white">
                          <v-icon>{{
                            contarPersonasSeleccionadas === 0
                              ? "fa-regular fa-circle"
                              : contarPersonasSeleccionadas === 1
                              ? "fa-solid fa-user"
                              : "fa-solid fa-users"
                          }}</v-icon>
                          <span
                            >{{
                              contarPersonasSeleccionadas === 0
                                ? " Ninguna persona seleccionada."
                                : contarPersonasSeleccionadas === 1
                                ? " 1 personada seleccionada."
                                : contarPersonasSeleccionadas + " personas seleccionadas"
                            }}
                          </span>
                        </v-system-bar>
            <v-data-table
              dense
              fixed-header
              :height="height - 120"
              :page.sync="page"
              :items="personas"
              :loading="loadTable"
              v-model="selectPersonas"
              :headers="headersPersona"
              :items-per-page="itemsPerPage"
              :search="searchPersonaValue"
              item-key="id"
              show-select
              sort-by="mes"
              class="elevation-1"
              checkbox-color="primary"
              :header-props="{
                'sort-icon': 'fa-solid fa-arrow-down-wide-short',
              }"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-text': 'Filas por página',
                'group-text': 'Agrupar',
                'items-per-page-options': [20, 30, 40, 50, -1],
                'all-rows': 'Todos',
              }"
            >
              <template v-slot:header="{}">
                <thead class="v-data-table-header">
                  <tr>
                    <th colspan="9">
                      <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on"> </v-btn>
                        </template>
                      </v-menu>
                    </th>
                  </tr>

                  <tr>
                    <th>
                      <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>fa-solid fa-ellipsis-vertical</v-icon>
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-item @click="seleccionarPersonasExistentes()">
                            <v-list-item-title>Existentes </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="seleccionarPersonasConCupo()">
                            <v-list-item-title>Con Cupo </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="seleccionarPersonasSinErrores()">
                            <v-list-item-title>Sin errores </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            @click="seleccionarPersonasExistentesSinErrores()"
                          >
                            <v-list-item-title
                              >Existentes y sin errores</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </th>
                    <th colspan="8">
                      <v-row v-if="mostrarBusquedas">
                        <v-col cols="12" sm="2" md="2">
                          <v-autocomplete
                            dense
                            hide-details
                            outlined
                            class="text-xs-center"
                            v-model="searchCencoPerValue"
                            :items="personas"
                            append-icon="search"
                            label="Cenco"
                            item-text="centro_costo"
                            item-value="centro_costo"
                            clearable
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-autocomplete
                            dense
                            hide-details
                            outlined
                            class="text-xs-center"
                            v-model="searchAreaPerValue"
                            :items="personas"
                            append-icon="search"
                            label="Área"
                            item-text="area"
                            item-value="area"
                            clearable
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-autocomplete
                            dense
                            hide-details
                            outlined
                            class="text-xs-center"
                            v-model="searchSubareaPerValue"
                            :items="personas"
                            append-icon="search"
                            label="Subarea"
                            item-text="subarea"
                            item-value="subarea"
                            clearable
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-autocomplete
                            dense
                            hide-details
                            outlined
                            class="text-xs-center"
                            v-model="searchCargoPerValue"
                            :items="personas"
                            append-icon="search"
                            label="Cargo"
                            item-text="cargo"
                            item-value="cargo"
                            clearable
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-autocomplete
                            dense
                            hide-details
                            outlined
                            class="text-xs-center"
                            v-model="searchGrupoPerValue"
                            :items="personas"
                            append-icon="search"
                            label="Grupo de Nómina"
                            item-text="grupo_nomina"
                            item-value="grupo_nomina"
                            clearable
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-text-field
                            dense
                            outlined
                            class="text-xs-center"
                            v-model="searchPersonaValue"
                            append-icon="search"
                            label="Persona"
                            hide-details
                            clearable
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:[`item.area`]="{ item }">
                <div class="font-weight-bold body-1 text--primary">
                  {{ item.cargo }}
                </div>

                <div class="font-weight-bold button text--secondary">
                  {{ item.subarea }}
                </div>
                <div class="font-weight-medium caption text--disabled">
                  {{ item.area }}
                </div>
              </template>
              <template v-slot:[`item.id_cupo`]="{ item }">
                <div
                  v-if="item.id_cupo"
                  class="font-weight-bold body-1 success--text"
                >
                  SI
                </div>
                <div v-else class="font-weight-bold body-1 error--text">NO</div>
              </template>
              <template v-slot:[`item.nombre_completo`]="{ item }">
                <div class="body-1">{{ item.nombre_completo }}</div>
              </template>

              <template v-slot:[`item.subsidio`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.real"
                  large
                  @save="guardarSubsidio"
                  @open="editSubsidio(item)"
                  save-text="Asignar"
                  cancel-text="Cancelar"
                >
                  <div>
                    <v-badge
                      color="red"
                      :value="item.subsidio === 'SS' ? 'P' : ''"
                      :content="item.subsidio === 'SS' ? 'PRESUP' : 0"
                      :class="
                        item.subsidio === 'N'
                          ? 'font-weight-black primary--text'
                          : 'font-weight-black primary--text'
                      "
                    >
                      {{ item.subsidio === "N" ? "NO" : "SI" }}
                    </v-badge>

                    <v-list-item-subtitle>{{
                      item.cant_subsidio > 0
                        ? $formatoFechaSpanish(item.fecha_subsidio_1)
                        : ""
                    }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{
                      item.cant_subsidio > 1
                        ? $formatoFechaSpanish(item.fecha_subsidio_2)
                        : ""
                    }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{
                      item.cant_subsidio > 2
                        ? $formatoFechaSpanish(item.fecha_subsidio_3)
                        : ""
                    }}</v-list-item-subtitle>
                  </div>

                  <template v-slot:input>
                    <v-app-bar
                      color="white"
                      class="font-weight-black primary--text"
                      elevate-on-scroll
                      flat
                    >
                      {{ item.nombre_completo }}
                      <v-spacer></v-spacer>
                    </v-app-bar>

                    <v-autocomplete
                      outlined
                      dense
                      ref="subsidio"
                      v-model="subsidio"
                      :items="subsidios"
                      :rules="[]"
                      label="Recibe Subsidio Prenatal/lactancia"
                      item-text="descripcion"
                      item-value="id"
                    ></v-autocomplete>
                    <div v-show="subsidio == 'S'">
                      <v-autocomplete
                        outlined
                        dense
                        ref="cant_subsidio"
                        v-model="cant_subsidio"
                        :items="cant_subsidios"
                        :rules="[]"
                        :error-messages="errorMessages"
                        label="Cantidad de subsidios"
                        required
                      ></v-autocomplete>
                    </div>
                    <div
                      v-show="
                        cant_subsidio == '1' ||
                        cant_subsidio == '2' ||
                        cant_subsidio == '3'
                      "
                    >
                      <v-text-field
                        outlined
                        type="date"
                        dense
                        ref="fecha_subsidio_1"
                        v-model="fecha_subsidio_1"
                        :rules="[]"
                        :error-messages="errorMessages"
                        label="Fecha inicio Subsidio 1"
                        required
                      ></v-text-field>
                    </div>
                    <div v-show="cant_subsidio == '2' || cant_subsidio == '3'">
                      <v-text-field
                        outlined
                        type="date"
                        dense
                        ref="fecha_subsidio_2"
                        v-model="fecha_subsidio_2"
                        :rules="[]"
                        :error-messages="errorMessages"
                        label="Fecha inicio Subsidio 2"
                        required
                      ></v-text-field>
                    </div>
                    <div v-show="cant_subsidio == '3'">
                      <v-text-field
                        outlined
                        type="date"
                        dense
                        ref="fecha_subsidio_3"
                        v-model="fecha_subsidio_3"
                        :rules="[]"
                        :error-messages="errorMessages"
                        label="Fecha inicio Subsidio 3"
                        required
                      ></v-text-field>
                    </div>
                  </template>
                </v-edit-dialog>
              </template>

              <template v-slot:[`item.grupo_nomina`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.real"
                  large
                  @save="guardarGrupoNomina()"
                  @open="editGrupoNomina(item)"
                  save-text="Asignar"
                  cancel-text="Cancelar"
                >
                  <div :class="'font-weight-black primary--text'">
                    {{ item.grupo_nomina }}
                  </div>

                  <template v-slot:input>
                    <v-app-bar
                      color="white"
                      class="font-weight-black primary--text"
                      elevate-on-scroll
                      flat
                    >
                      {{ item.nombre_completo }}
                      <v-spacer></v-spacer>
                    </v-app-bar>

                    <v-autocomplete
                      outlined
                      dense
                      ref="id_grupo_nomina"
                      v-model="id_grupo_nomina"
                      :items="grupos"
                      :rules="[$rules.requerido]"
                      :error-messages="errorMessages"
                      item-text="descripcion"
                      item-value="id"
                      label="Grupo Nómina"
                      required
                    ></v-autocomplete>
                  </template>
                </v-edit-dialog>
              </template>

              <template v-slot:[`item.codigo`]="{ item }">
                <div
                  :class="isNaN(item.codigo) ? 'error--text' : 'black--text'"
                >
                  <v-badge
                    color="red"
                    :value="item.error"
                    icon="fa-solid fa-exclamation"
                  >
                    {{ item.codigo }}
                  </v-badge>
                </div>
              </template>
              <template v-slot:[`item.fecha_ingreso`]="{ item }">
                <div>
                  {{
                    item.fecha_ingreso === null
                      ? ""
                      : formatoFechaSpanish(item.fecha_ingreso)
                  }}
                </div>
              </template>
              <template v-slot:[`item.fecha_salida`]="{ item }">
                <div>
                  {{
                    item.fecha_salida === null
                      ? ""
                      : formatoFechaSpanish(item.fecha_salida)
                  }}
                </div>
              </template>
              <template v-slot:no-data>
                No hay datos de personas disponibles
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-dialog>
      <DialogDetallesPlanilla ref="detallesDialog" />
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { json2excel, excel2json } from "js2excel";
import DialogDetallesPlanilla from "./DialogDetallesPlanilla.vue";

export default {
  components: { DialogDetallesPlanilla },
  data() {
    return {
      mes_real_hasta: "",
      codigoVersionPresupuesto: "",
      descripcionVersionPresupuesto: "",
      salarioMinimoVersionPresupuesto: 0,
      calculoReal: "",
      calculoPresupuesto: "",
      dialogVersionPresupuesto: false,
      es_oficial: false,
      gestion: 0,
      id_version_basado: "",
      otraVersion: false,
      filtroUniformes: "",
      salario_minimo: 0,
      subsidio: "",
      porcentaje_sueldo: "100",
      porcentaje_comision: "100",
      porcentaje_vacacion: "100",
      restar_vacacion_pasada: false,
      id_grupo_nomina: "",
      cant_subsidio: "",
      fecha_subsidio_1: "",
      fecha_subsidio_2: "",
      fecha_subsidio_3: "",
      cant_subsidios: [0, 1, 2, 3],
      subsidios: [
        { id: "S", descripcion: "SI" },
        { id: "N", descripcion: "NO" },
      ],
      areaProcesada: "",
      areaProcesadaCount: 0,
      areasTotales: 0,
      interval: {},
      valor: 0,
      width: 0,
      height: 0,
      isMobile: false,

      i: 0,
      load: false,
      loadTable: false,
      loadBorrar: false,
      mostrarTabla: false,

      overlay: false,
      overlay2: false,

      incluirIncremento: false,
      //incluirIncGob: false,
      mostrarBusquedas: true,
      presupuesto_lineas: [],
      personaPresupuesto: [],
      presupuesto_lineas_excel: [],
      presupuestos: [],
      versionPresupuestos: [],
      linea_ventas: [],
      personas: [],
      cuentasContables: [],
      centroCostos: [],
      subcategorias: [],
      planillas: [],
      id_planilla: null,
      selectPersonas: [],
      selectDatosPresup: [],
      selectPersonaPresup: [],
      selectUniformes: [],
      uniformeList: [],
      grupos: [],
      
      vistas: [],
      personasIncremento: [],
      personasIncrementoSelect: [],
      selectPersonasIncremento: [],
      mesesVersion: [
        { id: 1, descripcion: "ENERO" },
        { id: 2, descripcion: "FEBRERO" },
        { id: 3, descripcion: "MARZO" },
        { id: 4, descripcion: "ABRIL" },
        { id: 5, descripcion: "MAYO" },
        { id: 6, descripcion: "JUNIO" },
        { id: 7, descripcion: "JULIO" },
        { id: 8, descripcion: "AGOSTO" },
        { id: 9, descripcion: "SEPTIEMBRE" },
        { id: 10, descripcion: "OCTUBRE" },
        { id: 11, descripcion: "NOVIEMBRE" },
        { id: 12, descripcion: "DICIEMBRE" },
        { id: 13, descripcion: "NINGUNO" },
      ],
      meses: [
        { id: 1, descripcion: "ENERO" },
        { id: 2, descripcion: "FEBRERO" },
        { id: 3, descripcion: "MARZO" },
        { id: 4, descripcion: "ABRIL" },
        { id: 5, descripcion: "MAYO" },
        { id: 6, descripcion: "JUNIO" },
        { id: 7, descripcion: "JULIO" },
        { id: 8, descripcion: "AGOSTO" },
        { id: 9, descripcion: "SEPTIEMBRE" },
        { id: 10, descripcion: "OCTUBRE" },
        { id: 11, descripcion: "NOVIEMBRE" },
        { id: 12, descripcion: "DICIEMBRE" },
      ],
      variablesList: [
        { id: "S", descripcion: "SUELDO BÁSICO" },
        { id: "B", descripcion: "BONO ANTIGÜEDAD" },
        { id: "SB", descripcion: "SUELDO BÁSICO + BONO ANTIGÜEDAD" },
        { id: "C", descripcion: "COMISIONES" },
        { id: "SC", descripcion: "SUELDO BÁSICO + COMISIONES" },
        { id: "BC", descripcion: "BONO ANTIGÜEDAD + COMISIONES" },
        {
          id: "SBC",
          descripcion: "SUELDO BÁSICO + BONO ANTIGÜEDAD + COMISIONES",
        },
        { id: "T", descripcion: "TOTAL" },
        { id: "SPC", descripcion: "SUELDO + PROMEDIO COMISIÓN" },
      ],
      dialog: false,
      dialogReal: false,
      editVersion: false,
      dialogPresupuesto: false,
      dialogUpload: false,
      dialogOficial: false,
      dialogExcel: false,
      dialogPersonaIncremento: false,
      usuario: this.$store.state.usuario.user,
      dialogCargaMasiva: false,
      dialogCargaMasivaReal: false,
      dialogUniformes: false,
      dialogEliminacion: false,
      dialogEliminacionPersona: false,
      dialogTotalDescuentos: false,
      dialogTablaVista: false,

      dialogSincronizarSueldos: false,
      boxEliminarPresupuesto: false,
      boxEliminarPersonaPresupuesto: false,
      searchPersIncNombre: "",
      searchPersIncCargo: "",
      searchPersIncCenco: "",
      variableCalculo: "",
      porcentaje: "100",
      modalFecha: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      presupSelect: false,
      nombreExcel:
        "Reporte " +
        new Date().getFullYear() +
        (new Date().getMonth() + 1) +
        new Date().getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds(),
      page: 1,
      itemsPerPage: -1,

      headers: [
        {
          text: "Op.",
          value: "opciones",
          groupable: false,
          sortable: false,
          width: "1%",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cód. SAC",
          value: "codigo",
          width: "1%",
          groupable: false,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Nombre",
          value: "nombre",
          groupable: false,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Área",
          value: "area",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Subárea",
          value: "subarea",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "cargo",
          align: "left",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cenco",
          value: "centro_costo",
          width: "1%",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Detalle",
          value: "detalle",
          align: "left",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha Ingreso",
          value: "fecha_ingreso",
          width: "1%",
          groupable: false,
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha Salida",
          value: "fecha_salida",
          width: "1%",
          groupable: false,
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Total",
          value: "total",
          width: "1%",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersPresupuesto: [
        {
          text: "Cuenta Contable",
          value: "cuenta_contable",
          align: "left",
          filter: this.filtroCuentaPresup,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cenco",
          value: "centro_costo",
          filter: this.filtroCencoPrespup,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Mes",
          value: "mes",
          align: "left",
          filter: this.filtroMesPresup,
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Subcategoría",
          value: "subcategoria",
          align: "left",
          filter: this.filtroSubcategoriaPrespup,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Monto Acumulado",
          value: "monto_total",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Monto",
          value: "monto",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Detalle",
          value: "detalle",
          align: "left",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
      ],
      headersPersona: [
        {
          text: "Código",
          value: "codigo",

          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cenco",
          value: "centro_costo",
          filter: this.filtroCencoPer,
          class: "dark primary white--text text-subtitle-2",
        },
        {
          text: "Nombre",
          value: "nombre_completo",

          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "area",
          filter: this.filtroAreaPer,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Tiene Cupo",
          value: "id_cupo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Subsidio",
          value: "subsidio",
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Subarea",
          value: "subarea",
          filter: this.filtroSubareaPer,
          class: "primary white--text text-subtitle-2",
          align: " d-none",
        },

        {
          text: "Cargo",
          value: "cargo",
          filter: this.filtroCargoPer,
          class: "primary white--text text-subtitle-2",
          align: " d-none",
        },
        {
          text: "Grupo",
          value: "grupo_nomina",
          filter: this.filtroGrupoPer,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Ingreso",
          value: "fecha_ingreso",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Salida",
          value: "fecha_salida",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],
      headersUniforme: [
        {
          text: "Código",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "descripcion",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Sexo",
          value: "genero",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Precio",
          value: "monto",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Activo",
          value: "estado",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersVista: [
        {
          text: "Cuenta Contable",
          value: "desc_cuc",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Centro Costo",
          value: "desc_cco",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Persona",
          value: "desc_pers",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Producto",
          value: "desc_lnv",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Enero",
          value: "enero",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Febrero",
          value: "febrero",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Marzo",
          value: "marzo",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Abril",
          value: "abril",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Mayo",
          value: "mayo",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Junio",
          value: "junio",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Julio",
          value: "julio",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Agosto",
          value: "agosto",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Septiembre",
          value: "septiembre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Octubre",
          value: "octubre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Noviembre",
          value: "noviembre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Diciembre",
          value: "diciembre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Total",
          value: "total",
          align: "center",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersPersonaIncremento: [
        {
          text: "Código",
          value: "codigo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cenco",
          value: "centro_costo",
          filter: this.filtroIncCenco,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Nombre",
          value: "nombre_completo",
          filter: this.filtroIncNombre,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "cargo",
          filter: this.filtroIncCargo,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha Ingreso",
          value: "fecha_ingreso",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Salario Actual",
          value: "salario_ref",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Salario Novus",
          value: "salario_novus",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Variación",
          value: "variacion",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
      ],

      search: "",
      searchPersona: "",
      searchCuentaValue: "",
      searchCuentaPresupValue: "",
      searchCencoPresupValue: "",
      searchSubcategoriaPresupValue: "",
      searchCencoPerValue: "",
      searchAreaPerValue: "",
      searchSubareaPerValue: "",
      searchCargoPerValue: "",
      searchGrupoPerValue: "",
      searchPersonaValue: "",
      searchMesValue: "",

      editedIndex: -1,
      editCodigo: false,
      mostrarErrores: false,

      id: "",

      id_presupuesto: "",
      id_version_presupuesto: "",

      id_cuenta_contable: "",
      id_centro_costo: "",
      tipo_presupuesto: "NOM",
      tipo_version_presupuesto: "",
      mesInicioCalculo: 1,
      monto: "",
      id_persona: "",
      id_subcategoria: "",
      file: null,
      valida: 0,
      fecha_cierre: "",
      nombreCompleto: "",
      validaMensaje: [],

      adCodigo: "",
      errorMessages: "",
    tipoCargaMasiva: "subcategoria",
    
    dialogVerDatos: false,
    
    searchNombreCargado: "",
    searchCargoCargado: "",
cargandoDatos: false,
    datosCargados: [],
    headersDatosCargados: [

      { text: 'Codigo', value: 'codigo' },

      { text: 'Nombre Completo', value: 'nombre_completo' },
      { text: 'Cargo', value: 'cargo' },
      { text: 'Tipo', value: 'tipo' },
      
      { text: 'Año', value: 'anio' },
      { text: 'Mes', value: 'mes' },
      { text: 'Valor (Monto/Días)', value: 'monto' },
    ],
stepUpload: 1,
      error: "",
    };
  },

  computed: {
    datosCargadosFiltrados() {
      let result = this.datosCargados;
      if (this.searchNombreCargado) {
        let s = this.searchNombreCargado.toLowerCase();
        result = result.filter(x => x.nombre_completo && x.nombre_completo.toLowerCase().includes(s));
      }
      if (this.searchCargoCargado) {
        let c = this.searchCargoCargado.toLowerCase();
        result = result.filter(x => x.cargo && x.cargo.toLowerCase().includes(c));
      }
      return result;
    },

    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Actualizar Registro";
    },
    formTitlePresupuesto() {
      return "Detalle del Presupuesto para: " + this.nombreCompleto;
    },
    contarPersonasSeleccionadas() {
      return this.selectPersonas.length;
    },

    form() {
      return {
        id_cuenta_contable: this.id_cuenta_contable,
        id_centro_costo: this.id_centro_costo,
        monto: this.monto,
        id_persona: this.id_persona,
        id_subcategoria: this.id_subcategoria,
      };
    },
    formVersionPresupuesto() {
      return {
        codigoVersionPresupuesto: this.codigoVersionPresupuesto,
        descripcionVersionPresupuesto: this.descripcionVersionPresupuesto,
        salarioMinimoVersionPresupuesto: this.salarioMinimoVersionPresupuesto,
        mes_real_hasta: this.mes_real_hasta,
      };
    },
    formPersona() {
      return {
        mesInicioCalculo: this.mesInicioCalculo,
      };
    },
    formSubsidio() {
      return {
        subsidio: this.subsidio,
        cant_subsidio: this.cant_subsidio,
        fecha_subsidio_1: this.fecha_subsidio_1,
        fecha_subsidio_2: this.fecha_subsidio_2,
        fecha_subsidio_3: this.fecha_subsidio_3,
      };
    },
    formGrupoNomina() {
      return {
        id_grupo_nomina: this.id_grupo_nomina,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogPersonaIncremento(val) {
      val || this.closeIncremento();
    },
    id_version_presupuesto(val) {
      if (val && this.versionPresupuestos && this.versionPresupuestos.length > 0) {
        let index = this.$obtenerIndicePorID(this.versionPresupuestos, val);
        if (index !== -1) {
          this.salario_minimo = this.versionPresupuestos[index].salario_minimo || 0;
        }
      } else {
        this.salario_minimo = 0;
      }
    },

    name() {
      this.errorMessages = "";
    },
  },

  created() {
    this.selectSubcategoria();
    this.selectGrupo();
    //this.listarPersona();

    this.selectPresupuesto();
    this.selectCuentasContables();
    this.selectCentroCostos();
    this.listarUniformes();
    this.listarPlanillas();
  },

  mounted() {
    this.getDimensions();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {

    
    mostrarDatosCargados() {
      this.dialogVerDatos = true;
      this.cargarDatosMasivos();
    },
    cargarDatosMasivos() {
      let me = this;
      me.cargandoDatos = true;
      let url = "api/presupuesto_lineas/obtenerDatosCargadosMasivos/" + me.tipoCargaMasiva + "/" + me.id_presupuesto + "/" + me.id_version_presupuesto;
      axios.get(url).then(function(response) {
        me.datosCargados = response.data;
        me.cargandoDatos = false;
        
        // Dynamic header
        me.headersDatosCargados[4].text = me.tipoCargaMasiva === 'vacaciones' ? 'Días Tomados' : 'Monto (Bs.)';
      }).catch(function(error) {
        console.log(error);
        me.cargandoDatos = false;
        me.$store.dispatch("setSnackbar", {
          text: "Ocurrió un error al cargar los datos.",
          color: "error"
        });
      });
    },
descargarPlantilla() {
      let me = this;
      let url = "api/presupuesto_lineas/descargarPlantillaMasiva/" + me.tipoCargaMasiva;
      
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // important for file download
      }).then((response) => {
        const href = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'Plantilla_' + (me.tipoCargaMasiva === 'vacaciones' ? 'Vacaciones' : 'Comisiones') + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      }).catch((err) => {
        me.$store.dispatch("setSnackbar", {
          text: "No se pudo descargar la plantilla.",
          color: "error",
        });
      });
    },

    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },
    listarPlanillas() {
      let me = this;
      axios.get("api/planillas/listar")
        .then(function (response) {
          me.planillas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },
    closeIncremento() {
      this.dialogPersonaIncremento = false;
    },
    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
    },

    mostrarAdvertenciaOficial() {
      this.dialogOficial = true;
    },

    guardarExcel() {
      let me = this;
      me.load=true;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        let url = "";
        if (me.tipoCargaMasiva === "subcategoria") {
          url = "api/presupuesto_lineas/cargarExcel/" + me.id_version_presupuesto + "/" + me.id_subcategoria + "/" + me.usuario;
        } else {
          url = "api/presupuesto_lineas/cargarVacacionesMasivas/" + me.id_presupuesto + "/" + me.usuario;
        }

        axios
          .put(url, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.load=false;
            me.stepUpload = 3;
            me.mostrarErrores = false;
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
            me.load=false;
            me.stepUpload = 3;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
        me.load=false;
      }
    },

    guardarLineaVenta() {
      if (this.validarLineaVenta() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.editedIndexCco) {
        let me = this;
        axios
          .put("api/centro_empleado/actualizar", {
            id_empleado: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentajeCco,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCentroCosto();
            me.limpiarCentroCosto();
            me.$store.dispatch("setSnackbar", {
              text: "Registro actualizado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: error, color: "error" });
          });
      } else {
        let me = this;
        axios
          .post("api/centro_empleado/crear", {
            id_empleado: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentajeCco,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCentroCosto();
            me.limpiarCentroCosto();
            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    listar() {
      let me = this;
      me.presupuesto_lineas = [];
      me.loadTable = true;
      axios
        .get(
          "api/personas/ListarPersonaPresupuesto/" + me.id_version_presupuesto
        )
        .then(function (response) {
          console.log("response.data",response.data);
          me.presupuesto_lineas = response.data;
          me.presupSelect = true;

          me.mostrarTabla = true;
          me.loadTable = false;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
            timeout: 1000,
          });
        });
    },

    listarPresup() {
      let me = this;
      me.loadTable = true;
      axios
        .get(
          "api/presupuesto_lineas/ListarPresupuestoNom/" +
            me.id_version_presupuesto +
            "/" +
            me.id_persona +
            "/" +
            me.usuario
        )
        .then(function (response) {
          me.loadTable = false;
          me.personaPresupuesto = response.data;
          me.presupSelect = true;

          me.mostrarTabla = true;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
            timeout: 1000,
          });
        });
    },

    listarVista() {
      let me = this;
      me.loadTable = true;
      axios
        .get("api/presupuesto_lineas/listarVista/" + me.id_version_presupuesto)
        .then(function (response) {
          me.vistas = response.data;
          me.loadTable = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarTipoVersion() {
      let me = this;

      axios
        .get(
          "api/version_presupuestos/tipoVersion/" + me.id_version_presupuesto
        )
        .then(function (response) {
          me.tipo_version_presupuesto = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },
    listarPersona() {
      let me = this;
      me.loadTable = true;
      if (!this.id_planilla) {
         me.personas = [];
         me.loadTable = false;
         return;
      }
      axios
        .get("api/personas/listarPorPlanilla/" + this.id_planilla)
        .then(function (response) {
          me.personas = response.data;
          me.loadTable = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarPersonaIncremento() {
      let me = this;
      me.loadTable = true;
      axios
        .get("api/personas/listar/" + true)
        .then(function (response) {
          me.loadTable = false;
          me.personasIncremento = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarUniformes() {
      let me = this;
      me.loadTable = true;
      axios
        .get("api/uniformes/listar")
        .then(function (response) {
          me.uniformeList = response.data;
          me.loadTable = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectGrupo() {
      let me = this;
      axios
        .get("api/grupo_nominas/select")
        .then(function (response) {
          me.grupos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectPresupuesto() {
      let me = this;
      axios
        .get("api/presupuestos/select")
        .then(function (response) {
          me.presupuestos = response.data;
          //me.id_presupuesto=response.data[0].id;
          //me.listar();
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },
    selectVersionPresupuesto() {
      let me = this;
      me.presupSelect = false;
      me.gestion =
        me.presupuestos[
          me.$obtenerIndicePorID(me.presupuestos, me.id_presupuesto)
        ].gestion;
      me.presupuesto_lineas = [];
      axios
        .get("api/version_presupuestos/select/" + me.id_presupuesto)
        .then(function (response) {
          me.versionPresupuestos = response.data;
          //me.id_presupuesto=response.data[0].id;
          //me.listar();
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },
    selectCuentasContables() {
      let me = this;
      axios
        .get("api/cuenta_contables/select")
        .then(function (response) {
          me.cuentasContables = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectCentroCostos() {
      let me = this;
      axios
        .get("api/centro_costos/select")
        .then(function (response) {
          me.centroCostos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    setFecha() {
      let me = this;
      //me.fecha_cierre=this.formatoFechaSpanish(me.fecha_cierre);
      me.modalFecha = false;
    },

    mostrarCarga() {
      this.dialogUpload = true;
    },
    mostrarPersonaIncremento() {
      this.listarPersonaIncremento();
      this.dialogPersonaIncremento = true;
    },
    seleccionarPersonasExistentes() {
      this.selectPersonas = [];
      //this.personas.forEach((element, index) => {
      //  this.selectPersonas.push(element);
      //});
      this.selectPersonas = this.personas.filter(
        (objeto) => !objeto.codigo.startsWith("EMP")
      );
    },
    seleccionarPersonasConCupo() {
      this.selectPersonas = [];
      //this.personas.forEach((element, index) => {
      //  this.selectPersonas.push(element);
      //});
      this.selectPersonas = this.personas.filter(
        (objeto) => objeto.id_cupo != null
        && objeto.area.includes(this.searchAreaPerValue)
        && objeto.subarea.includes(this.searchSubareaPerValue)
        && objeto.cargo.includes(this.searchCargoPerValue)
        && objeto.grupo_nomina.includes(this.searchGrupoPerValue)        
        && objeto.centro_costo.includes(this.searchCencoPerValue)
      );
     
      
    
    },
    seleccionarPersonasSinErrores() {
      this.selectPersonas = [];

      this.selectPersonas = this.personas.filter((objeto) => objeto.error === 0
      && objeto.area.includes(this.searchAreaPerValue)
        && objeto.subarea.includes(this.searchSubareaPerValue)
        && objeto.cargo.includes(this.searchCargoPerValue)
        && objeto.grupo_nomina.includes(this.searchGrupoPerValue)        
        && objeto.centro_costo.includes(this.searchCencoPerValue)
    );
    },
    seleccionarPersonasExistentesSinErrores() {
      this.selectPersonas = [];
      this.selectPersonas = this.personas.filter(
        (objeto) => !objeto.codigo.startsWith("EMP")
        && objeto.area.includes(this.searchAreaPerValue)
        && objeto.subarea.includes(this.searchSubareaPerValue)
        && objeto.cargo.includes(this.searchCargoPerValue)
        && objeto.grupo_nomina.includes(this.searchGrupoPerValue)        
        && objeto.centro_costo.includes(this.searchCencoPerValue)
      );
      this.selectPersonas = this.selectPersonas.filter(
        (objeto) => objeto.error === 0
        && objeto.area.includes(this.searchAreaPerValue)
        && objeto.subarea.includes(this.searchSubareaPerValue)
        && objeto.cargo.includes(this.searchCargoPerValue)
        && objeto.grupo_nomina.includes(this.searchGrupoPerValue)        
        && objeto.centro_costo.includes(this.searchCencoPerValue)
      );
    },

    mostrarDialogCargaMasiva() {
      if (this.selectPersonas.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos una persona.",
          color: "error",
        });
        return;
      }
      if (this.validarPersona() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar el mes de inicio de cálculo.",
          color: "error",
        });
        return;
      }

      this.dialogCargaMasiva = true;
    },
    mostrarDialogCargaMasivaReal() {
      this.mesInicioCalculo = 1;
      this.dialogCargaMasivaReal = true;
    },
    mostrarDialogEliminacion() {
      if (this.selectDatosPresup.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos un registro a eliminar.",
          color: "error",
        });
        return;
      }
      this.dialogEliminacion = true;
    },
    mostrarDialogEliminacionPersona() {
      //console.log(this.selectPersonaPresup.length +" ssssssss");
      if (this.selectPersonaPresup.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos un registro a eliminar.",
          color: "error",
        });
        return;
      }
      this.dialogEliminacionPersona = true;
    },
    mostrarDialogTotalDescuentos() {
      if (this.validarPersona() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      this.dialogTotalDescuentos = true;
    },

    mostrarDialogVista() {
      this.dialogTablaVista = true;
      this.listarVista();
    },


    modificarSalarios() {
      //codigo para guardar
      let me = this;

      axios
        .post("api/personas/ModificacíonSalarial", {
          porcentaje: me.porcentajeInc,
          persona: me.selectPersonasIncremento,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.closePorcentaje();
          //me.listar();
          me.listarPersonaIncremento();
          me.$store.dispatch("setSnackbar", {
            text: " Salarios modificados exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    editItem(item) {
      this.id = item.id;
      this.id_cuenta_contable = item.id_cuenta_contable;
      this.id_centro_costo = item.id_centro_costo;

      this.monto = item.monto;
      this.id_persona = item.id_persona;
      this.id_subcategoria = item.id_subcategoria;
      this.nombreCompleto = item.nombre;

      this.editedIndex = 1;
      this.editCodigo = false;
      this.dialogPresupuesto = true;
      this.listarPresup();
    },
    mostrarCuadroGeneracionPresupuesto() {
      this.editCodigo = true;

      if (this.tipo_version_presupuesto === "R") {
        this.mostrarDialogCargaMasivaReal();
      } else {
        this.dialog = true;
      }
    },

    close() {
      this.dialog = false;
      this.dialogCargaMasiva = false;
    },
    closeReal() {
      this.dialogReal = false;
    },
    closeDetallePresup() {
      this.dialogPresupuesto = false;
      this.searchCuentaPresupValue = "";
      this.searchCencoPresupValue = "";
      this.searchMesValue = "";
      this.searchSubcategoriaPresupValue = "";
      this.boxEliminarPresupuesto = false;
    },

    limpiar() {
      this.id = "";
      this.id_cuenta_contable = "";
      this.id_centro_costo = "";
      this.tipo_presupuesto = "NOM";
      this.mesInicioCalculo = 1;
      this.monto = "";
      this.id_persona = "";
      this.id_subcategoria = "";

      this.validaMensaje = [];
      this.editedIndex = -1;
    },
    limpiarUpload() {
      this.stepUpload = 1;
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    guardarSueldo(item) {
      let me = this;

      axios
        .put(
          "api/personas/ActualizarSalario/" +
            item.id +
            "/" +
            item.salario_ref +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.listarPersonaIncremento();
          me.$store.dispatch("setSnackbar", {
            text: "Salario actualizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    cambiarSalario() {
      if (!this.id_version_presupuesto) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar una versión de presupuesto.",
          color: "error",
        });
        return;
      }

      let me = this;
      axios
        .put("api/version_presupuestos/ActualizarSalarioMinimo", {
          id: me.id_version_presupuesto,
          salario_minimo: me.salario_minimo,
          usuario: me.usuario,
        })
        .then(function (response) {
          // Update the local array too
          let index = me.$obtenerIndicePorID(me.versionPresupuestos, me.id_version_presupuesto);
          if (index !== -1) {
            me.versionPresupuestos[index].salario_minimo = me.salario_minimo;
          }
          me.$store.dispatch("setSnackbar", {
            text: "Salario mínimo de la versión modificado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: (error.response && error.response.data) || "Ocurrió un error",
            color: "error",
          });
        });
    },
    cancelarSueldo() {
      let me = this;
      me.$store.dispatch("setSnackbar", {
        text: "Acción cancelada.",
        color: "info",
      });
    },

    guardar() {
      if (this.validar(this.form) > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.editedIndex > -1) {
        //codigo para editar
        let me = this;
        axios
          .put("api/presupuesto_lineas/actualizar", {
            id: me.id,
            id_presupuesto: me.id_presupuesto,
            id_version_presupuesto: me.id_version_presupuesto,
            id_cuenta_contable: me.id_cuenta_contable,
            id_centro_costo: me.id_centro_costo,
            tipo_presupuesto: me.tipo_presupuesto,
            mes: me.mesInicioCalculo,
            monto: me.monto,
            id_persona: me.id_persona,
            id_subcategoria: me.id_subcategoria,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/presupuesto_lineas/crear", {
            codigo: me.codigo,
            id_presupuesto: me.id_presupuesto,
            id_version_presupuesto: me.id_version_presupuesto,
            id_cuenta_contable: me.id_cuenta_contable,
            id_centro_costo: me.id_centro_costo,
            tipo_presupuesto: me.tipo_presupuesto,
            mes: me.mesInicioCalculo,
            monto: me.monto,
            id_persona: me.id_persona,
            id_subcategoria: me.id_subcategoria,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },
    guardarVersionPresupuesto() {
      let me = this;
      if (me.validar(me.formVersionPresupuesto) > 0) {
        me.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (me.editVersion) {
        //codigo para editar

        axios
          .put("api/version_presupuestos/actualizar", {
            id: me.id_version_presupuesto,
            codigo: me.codigoVersionPresupuesto,
            descripcion: me.descripcionVersionPresupuesto,
            salario_minimo: me.salarioMinimoVersionPresupuesto,
            id_presupuesto: me.id_presupuesto,
            mes_real_hasta: me.mes_real_hasta,
            es_oficial: me.es_oficial,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeVersionPresupuesto();
            me.selectVersionPresupuesto();
            me.listar();
            me.$store.dispatch("setSnackbar", {
              text: " Versión modificada exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar

        axios
          .post("api/version_presupuestos/crear", {
            codigo: me.codigoVersionPresupuesto,
            descripcion: me.descripcionVersionPresupuesto,
            salario_minimo: me.salarioMinimoVersionPresupuesto,
            id_presupuesto: me.id_presupuesto,
            mes_real_hasta: me.mes_real_hasta,
            id_version_base: me.$esNulo(me.id_version_basado)
              ? 0
              : me.id_version_basado,
            es_oficial: me.es_oficial,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeVersionPresupuesto();
            me.selectVersionPresupuesto();
            me.id_version_presupuesto = response.data;
            me.listar();
            me.$store.dispatch("setSnackbar", {
              text: " Versión creada exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },
    mostrarProgreso() {
      this.overlay = true;
      this.valor = 0;
      this.i = 0;
      this.i = this.selectPersonas.length * 2;

      this.interval = setInterval(() => {
        if (this.valor === 100) {
          return (this.valor = 0);
        }
        this.valor += 1;
      }, this.i);
    },
    ocultarProgreso() {
      this.overlay = false;
      clearInterval(this.interval);
    },
    descargarReporte() {
      let me = this;
      me.load = true;
      axios({
        url:
          "api/presupuesto_lineas/ExportarExcelNomA/" +
          this.id_version_presupuesto, //FALTA IMPLEMENTAR CORRECTAMENTE  ID_VERSION_PRESUPUESTO
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "DetallePresupuesto - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
      });
    },
    descargarReporteOtrosGastos() {
      console.log("Descargando reporte de otros gastos...");
      let me = this;
      me.load = true;
      axios({
        url:
          "api/seguimiento_lineas/ExportarExcelNominasOtrosGastos/" +
          this.id_version_presupuesto, //FALTA IMPLEMENTAR CORRECTAMENTE  ID_VERSION_PRESUPUESTO
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "DetallePresupuestoOtrosGastos - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
      });
    },
    descargarReportePresupRealEstim() {
      let me = this;
      me.load = true;
      axios({
        url:
          "api/presupuesto_lineas/ExportarExcelPresupEstimReal/" +
          this.id_version_presupuesto, //FALTA IMPLEMENTAR CORRECTAMENTE  ID_VERSION_PRESUPUESTO
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "ReporteEstimRealPresup - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
      });
    },
    descargarReporteAnalisis() {
      let me = this;
      me.load = true;
      axios({
        url:
          "api/presupuesto_lineas/ExportarExcelResumenPresupuesto/" +
          this.id_version_presupuesto,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "AnalisisVariacion - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
      });
    },
    descargarReporteDetallePresupuestoCuentaCategoriaSubcategoria() {
      let me = this;
      me.load = true;
      try {
        axios({
          url:
            "api/presupuesto_lineas/ExportarExcelDetallePresupuestoCuentaCategoriaSubcategoria/" +
            this.id_version_presupuesto,
          method: "GET",
          responseType: "blob", // important
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              "Reporte Cuenta Subcategoria - " + Date.now().toString() + ".xlsx"
            );
            document.body.appendChild(link);
            link.click();
            me.load = false;
          })
          .catch((error) => {
            console.error("Error al descargar el reporte:", error);
            me.$store.dispatch("setSnackbar", {
              text: "Ocurrió un error al intentar descargar el reporte.",
              color: "success",
            });

            me.load = false;
          });
      } catch (error) {
        console.error("Error inesperado:", error);
        me.$store.dispatch("setSnackbar", {
          text: "Ocurrió un error inesperado.",
          color: "success",
        });

        me.load = false;
      }
    },
    descargarReporteFiniquitos() {
      let me = this;
      me.load = true;
      axios({
        url:
          "api/presupuesto_lineas/ExportarExcelFiniquitosGestion/" +
          this.id_version_presupuesto, ///FALTA AGREGAR ID_VERSION_PRESUPUESTO
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "ReporteFiniquitos - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
      });
    },
    descargarRepContable(categoria, esReal, titulo) {
      let me = this;
      me.load = true;
      axios({
        url:
          "api/reportes/ExportarExcelReporteContable/" +
          this.id_version_presupuesto +
          "/" +
          categoria +
          "/" +
          esReal +
          "/" +
          titulo,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", titulo + Date.now().toString() + ".xlsx");
        document.body.appendChild(link);
        link.click();
        me.load = false;
      });
    },
    descargarRepContablePasivo(titulo) {
      let me = this;
      me.load = true;
      axios({
        url:
          "api/reportes/ExportarExcelReporteContablePasivo/" +
          this.id_version_presupuesto +
          "/" +
          titulo,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", titulo + Date.now().toString() + ".xlsx");
        document.body.appendChild(link);
        link.click();
        me.load = false;
      });
    },

    descargarReporteAnexoB() {
      let me = this;
      me.load = true;
      axios({
        url:
          "api/reportes/ExportarExcelAnexoB/" +
          this.id_version_presupuesto +
          "/" +
          this.variableCalculo +
          "/" +
          this.porcentaje,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Anexo2 - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
        me.dialogExcel = false;
      });
    },
    descargarOtrosGastosConsolidado(cat1, cat2, cat3) {
      let me = this;
      me.load = true;
      axios({
        url:
          "api/reportes/ExportarExcelOtrosGastosConsolidado/" +
          this.id_version_presupuesto +
          "/" +
          cat1 +
          "/" +
          cat2 +
          "/" +
          cat3,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "OtrosGastosConsolidado - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
        me.dialogExcel = false;
      });
    },

    
async generarCargaMasiva() {
  // Código para guardar
  let personas = [];
  let count = 1;
  if (this.selectPersonas.length == 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar al menos una persona.",
      color: "error",
    });
    return;
  }
  
  if (this.validarPersona() > 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar el mes de inicio de cálculo.",
      color: "error",
    });
    return;
  }

  let me = this;
  let personasPorArea = me.selectPersonas.reduce((acc, persona) => {
    let area = persona.area; // Asume que cada persona tiene una propiedad 'area'
    if (!acc[area]) {
      acc[area] = [];
    }
    acc[area].push(persona);
    return acc;
  }, {});

  me.overlay2 = true;
  me.close();
  console.log("planilla:", me.id_planilla);
  // Iterar sobre las áreas y hacer solicitudes de forma secuencial
  for (const area of Object.keys(personasPorArea)) {
    personas = personasPorArea[area];
    this.areaProcesadaCount = count;
    this.areaProcesada = area;
    this.areasTotales = Object.keys(personasPorArea).length;
    try {
      const response = await 
      axios
        .post("api/presupuesto_lineas/CargaMasivaNominasOptimizada", {
          id_presupuesto: me.id_presupuesto,
          id_version_presupuesto: me.id_version_presupuesto,
          tipo_presupuesto: me.tipo_presupuesto,
          PersonasIds: personas.map(p => p.id),
          mes: me.mesInicioCalculo,
          porcentaje_sueldo: me.porcentaje_sueldo,
          porcentaje_comision: me.porcentaje_comision,
          porcentaje_vacacion: me.porcentaje_vacacion,
          incremento: me.incluirIncremento,
          restar_vacacion_pasada: me.restar_vacacion_pasada,
          id_planilla: me.id_planilla,
          //incremento_gobierno: me.incluirIncGob,
          usuario: me.usuario,
        })
      
      me.$store.dispatch("setSnackbar", {
        text: response.data,
        color: "success",
      });
    } catch (error) {
      me.$store.dispatch("setSnackbar", {
        text: error.response.data,
        color: "error",
      });
    }
    count++;
  }
  me.areaProcesada = "";
  me.areaProcesadaCount = 0;
  me.areasTotales = 0;
  me.dialogReplicar = false; 
  me.listar();
  me.limpiar();
  me.overlay2 = false; 
         
},



async generarSubsidio() {
  // Código para guardar
  let personas = [];
  let count = 1;
  if (this.selectPersonas.length == 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar al menos una persona.",
      color: "error",
    });
    return;
  }
  
  if (this.validarPersona() > 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar el mes de inicio de cálculo.",
      color: "error",
    });
    return;
  }

  let me = this;
  let personasPorArea = me.selectPersonas.reduce((acc, persona) => {
    let area = persona.area; // Asume que cada persona tiene una propiedad 'area'
    if (!acc[area]) {
      acc[area] = [];
    }
    acc[area].push(persona);
    return acc;
  }, {});

  me.overlay2 = true;
  me.close();

  // Iterar sobre las áreas y hacer solicitudes de forma secuencial
  for (const area of Object.keys(personasPorArea)) {
    personas = personasPorArea[area];
    this.areaProcesadaCount = count;
    this.areaProcesada = area;
    this.areasTotales = Object.keys(personasPorArea).length;
    try {
      const response = await 
      axios
      .post("api/presupuesto_lineas/CalcularSubsidios", {
          id_presupuesto: me.id_presupuesto,
          id_version_presupuesto: me.id_version_presupuesto,
          tipo_presupuesto: me.tipo_presupuesto,
          persona: personas,
          mes: me.mesInicioCalculo,
          id_planilla: me.id_planilla,
          usuario: me.usuario,
        })
      
      me.$store.dispatch("setSnackbar", {
        text: response.data,
        color: "success",
      });
    } catch (error) {
      me.$store.dispatch("setSnackbar", {
        text: error.response.data,
        color: "error",
      });
    }
    count++;
  }
  me.areaProcesada = "";
  me.areaProcesadaCount = 0;
  me.areasTotales = 0;
  me.dialogReplicar = false; 
  me.listar();
  me.limpiar();
  me.overlay2 = false; 

  
         
},


    generarSubsidio2() {
      if (this.selectPersonas.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos una persona.",
          color: "error",
        });
        return;
      }
      if (this.validarPersona() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar el mes de inicio de cálculo.",
          color: "error",
        });
        return;
      }
      let me = this;
      me.close();
      me.mostrarProgreso();
      me.overlay = true;
      axios
        .post("api/presupuesto_lineas/CalcularSubsidios", {
          id_presupuesto: me.id_presupuesto,
          id_version_presupuesto: me.id_version_presupuesto,
          tipo_presupuesto: me.tipo_presupuesto,
          persona: me.selectPersonas,
          mes: me.mesInicioCalculo,
          id_planilla: me.id_planilla,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.dialogReplicar = false;
          me.overlay = false;
          me.ocultarProgreso();
          me.listar();
          me.limpiar();
          me.close();
          me.$store.dispatch("setSnackbar", {
            text: "Cálculo de Subsidios para los empleados seleccionados realizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });

          me.dialogReplicar = false;
          me.overlay = false;
          me.ocultarProgreso();
        });
    },


generarOtrosGastos2() {
      let personas= [];
      let personas22= this.selectPersonas;
  if (this.selectPersonas.length == 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar al menos una persona.",
      color: "error",
    });
    return;
  }

  if (this.validarPersona() > 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar el mes de inicio de cálculo.",
      color: "error",
    });
    return;
  }

  let me = this;
  me.mostrarProgreso();

  // Paso 1: Agrupar las personas por área
  let personasPorArea = me.selectPersonas.reduce((acc, persona) => {
    let area = persona.area; // Asume que cada persona tiene una propiedad 'area'
    if (!acc[area]) {
      acc[area] = [];
    }
    acc[area].push(persona);
    return acc;
  }, {});

  // Paso 2: Iterar sobre cada área y enviar las personas agrupadas
  Object.keys(personasPorArea).forEach(area => {
    personas = personasPorArea[area];
    console.log("Personas del área", personas);
    console.log("Personas ", me.selectPersonas);
    axios
      .post("api/presupuesto_lineas/CargaMasivaOtrosGastos", {
        id_presupuesto: me.id_presupuesto,
        id_version_presupuesto: me.id_version_presupuesto,
        tipo_presupuesto: me.tipo_presupuesto,
        personas: personas22, // Enviar todas las personas del área actual
        mes: me.mesInicioCalculo,
        id_planilla: me.id_planilla,
        usuario: me.usuario,
      })
      .then(function (response) {
        me.$store.dispatch("setSnackbar", {
          text: `Área ${area}: ${response.data}`,
          color: "success",
        });
      })
      .catch(function (error) {
        me.$store.dispatch("setSnackbar", {
          text: `Área ${area}: ${error.response.data}`,
          color: "error",
        });
      })
      .finally(() => {
        me.ocultarProgreso();
      });
  });

  me.close();
},



async generarOtrosGastos() {
  // Código para guardar
  let personas = [];
  let count = 1;
  if (this.selectPersonas.length == 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar al menos una persona.",
      color: "error",
    });
    return;
  }
  
  if (this.validarPersona() > 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar el mes de inicio de cálculo.",
      color: "error",
    });
    return;
  }

  let me = this;
  let personasPorArea = me.selectPersonas.reduce((acc, persona) => {
    let area = persona.area; // Asume que cada persona tiene una propiedad 'area'
    if (!acc[area]) {
      acc[area] = [];
    }
    acc[area].push(persona);
    return acc;
  }, {});

  me.overlay2 = true;
  me.close();

  // Iterar sobre las áreas y hacer solicitudes de forma secuencial
  for (const area of Object.keys(personasPorArea)) {
    personas = personasPorArea[area];
    this.areaProcesadaCount = count;
    this.areaProcesada = area;
    this.areasTotales = Object.keys(personasPorArea).length;
    try {
      const response = await axios.post("api/presupuesto_lineas/CargaMasivaOtrosGastos", {
        id_presupuesto: me.id_presupuesto,
        id_version_presupuesto: me.id_version_presupuesto,
        tipo_presupuesto: me.tipo_presupuesto,
        persona: personas,
        mes: me.mesInicioCalculo,
        usuario: me.usuario,
      });

      
      me.$store.dispatch("setSnackbar", {
        text: response.data,
        color: "success",
      });
    } catch (error) {
      me.$store.dispatch("setSnackbar", {
        text: error.response.data,
        color: "error",
      });
    }
    count++;
  }
  me.areaProcesada = "";
  me.areaProcesadaCount = 0;
  me.areasTotales = 0;
  me.dialogReplicar = false;
  me.ocultarProgreso();
  me.listar();
  me.limpiar();
  me.overlay2 = false;
},

    
async generarUniformes() {
  // Código para guardar
  let personas = [];
  let count = 1;
  
  if (this.selectPersonas.length == 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar al menos una persona.",
      color: "error",
    });
    return;
  }
  if (this.selectUniformes.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos un uniforme.",
          color: "error",
        });
        return;
      }
  
  if (this.validarPersona() > 0) {
    this.$store.dispatch("setSnackbar", {
      text: "Debe seleccionar el mes de inicio de cálculo.",
      color: "error",
    });
    return;
  }

  let me = this;
  me.dialogUniformes = false;
  let personasPorArea = me.selectPersonas.reduce((acc, persona) => {
    let area = persona.area; // Asume que cada persona tiene una propiedad 'area'
    if (!acc[area]) {
      acc[area] = [];
    }
    acc[area].push(persona);
    return acc;
  }, {});

  me.overlay2 = true;
  me.close();

  // Iterar sobre las áreas y hacer solicitudes de forma secuencial
  for (const area of Object.keys(personasPorArea)) {
    personas = personasPorArea[area];
    this.areaProcesadaCount = count;
    this.areaProcesada = area;
    this.areasTotales = Object.keys(personasPorArea).length;
    try {
      const response = await 
      axios
        .post("api/presupuesto_lineas/CalcularUniformes", {
          id_presupuesto: me.id_presupuesto,
          id_version_presupuesto: me.id_version_presupuesto,
          tipo_presupuesto: me.tipo_presupuesto,
          persona: personas,
          uniforme: me.selectUniformes,
          mes: me.mesInicioCalculo,
          id_planilla: me.id_planilla,
          usuario: me.usuario,
        })
      
      me.$store.dispatch("setSnackbar", {
        text: response.data,
        color: "success",
      });
    } catch (error) {
      me.$store.dispatch("setSnackbar", {
        text: error.response.data,
        color: "error",
      });
    }
    count++;
  }
  me.areaProcesada = "";
  me.areaProcesadaCount = 0;
  me.areasTotales = 0;
  me.dialogReplicar = false; 
  me.listar();
  me.limpiar();
  me.overlay2 = false; 
         
},









generarUniformes2() {
      //codigo para guardar
      
      let me = this;
      me.close();
      me.dialogUniformes = false;
      me.overlay = true;
      axios
        .post("api/presupuesto_lineas/CalcularUniformes", {
          id_presupuesto: me.id_presupuesto,
          id_version_presupuesto: me.id_version_presupuesto,
          tipo_presupuesto: me.tipo_presupuesto,
          persona: me.selectPersonas,
          uniforme: me.selectUniformes,
          mes: me.mesInicioCalculo,
          id_planilla: me.id_planilla,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.dialogReplicar = false;

          me.overlay = false;
          me.listar();
          me.limpiar();
          me.$store.dispatch("setSnackbar", {
            text: "Cálculo de Uniformes para los empleados seleccionados realizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },


    generarCargaMasiva2() {
      //codigo para guardar
      let me = this;
      me.mostrarProgreso();
      me.close();
      axios
        .post("api/presupuesto_lineas/CargaMasivaNominasOptimizada", {
          id_presupuesto: me.id_presupuesto,
          id_version_presupuesto: me.id_version_presupuesto,
          tipo_presupuesto: me.tipo_presupuesto,
          PersonasIds: me.selectPersonas.map(p => p.id),
          mes: me.mesInicioCalculo,
          porcentaje_sueldo: me.porcentaje_sueldo,
          porcentaje_comision: me.porcentaje_comision,
          porcentaje_vacacion: me.porcentaje_vacacion,
          incremento: me.incluirIncremento,
          restar_vacacion_pasada: me.restar_vacacion_pasada,
          id_planilla: me.id_planilla,
          //incremento_gobierno: me.incluirIncGob,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.dialogReplicar = false;
          me.ocultarProgreso();
          me.listar();
          me.limpiar();

          me.$store.dispatch("setSnackbar", {
            text: "Cálculo de los conceptos para los empleados seleccionados realizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
          me.ocultarProgreso();
        });
    },

    generarCargaMasivaReal() {
      //codigo para guardar
      let me = this;
      me.mostrarProgreso();
      me.close();
      axios
        .post("api/presupuesto_lineas/CargaMasivaNominasReal", {
          id_presupuesto: me.id_presupuesto,
          id_version_presupuesto: me.id_version_presupuesto,
          tipo_presupuesto: me.tipo_presupuesto,
          persona: me.selectPersonas,
          mes: me.mesInicioCalculo,
          porcentaje_sueldo: me.porcentaje_sueldo,
          porcentaje_comision: me.porcentaje_comision,
          porcentaje_vacacion: me.porcentaje_vacacion,
          incremento: me.incluirIncremento,
          restar_vacacion_pasada: me.restar_vacacion_pasada,
          id_planilla: me.id_planilla,
          //incremento_gobierno: me.incluirIncGob,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.dialogReplicar = false;
          me.ocultarProgreso();
          me.listar();
          me.dialogCargaMasivaReal = false;

          me.$store.dispatch("setSnackbar", {
            text: "Cálculo de los conceptos realizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
          me.ocultarProgreso();
        });
    },

    selectSubcategoria() {
      let me = this;

      axios
        .get("api/subcategorias/SelectCargaMasiva")
        .then(function (response) {
          me.subcategorias = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    editSubsidio(item) {
      this.id = item.id;
      this.subsidio = item.subsidio.substring(0, 1);
      this.cant_subsidio = item.cant_subsidio;
      this.fecha_subsidio_1 = this.$formatoFecha(item.fecha_subsidio_1);
      this.fecha_subsidio_2 = this.$formatoFecha(item.fecha_subsidio_2);
      this.fecha_subsidio_3 = this.$formatoFecha(item.fecha_subsidio_3);
    },
    editGrupoNomina(item) {
      this.id = item.id;
      this.id_grupo_nomina = item.id_grupo_nomina;
    },

    guardarSubsidio() {
      if (this.validarSubsidio() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.fecha_subsidio_1 == null) {
        this.fecha_subsidio_1 = "";
      }
      if (this.fecha_subsidio_2 == null) {
        this.fecha_subsidio_2 = "";
      }
      if (this.fecha_subsidio_3 == null) {
        this.fecha_subsidio_3 = "";
      }
      if (this.$esNulo(this.cant_subsidio)) {
        this.cant_subsidio = "0";
      }

      let me = this;
      const formData = new FormData();
      formData.append("id", this.id);

      formData.append("subsidio", this.subsidio);
      formData.append("cant_subsidio", this.cant_subsidio);
      formData.append("fecha_subsidio_1", this.fecha_subsidio_1);
      formData.append("fecha_subsidio_2", this.fecha_subsidio_2);
      formData.append("fecha_subsidio_3", this.fecha_subsidio_3);
      formData.append("usuario", this.usuario);
      axios
        .put("api/personas/GuardarSubsidios", formData)
        .then(function (response) {
          me.listarPersona();

          me.$store.dispatch("setSnackbar", {
            text: "Registro actualizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
          me.ocultarProgreso();
        });
    },
    guardarGrupoNomina() {
      if (this.validarGrupoNomina() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      let me = this;
      const formData = new FormData();
      formData.append("id_persona", this.id);
      formData.append("id_grupo_nomina", this.id_grupo_nomina);
      formData.append("usuario", this.usuario);
      axios
        .put("api/personas/GuardarGrupoNomina", formData)
        .then(function (response) {
          me.listarPersona();

          me.$store.dispatch("setSnackbar", {
            text: "Registro actualizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
          me.ocultarProgreso();
        });
    },

    
    calcularMesesRealesPresup() {
      if (this.mes_real_hasta === "") {
        this.calculoReal = "";
        this.calculoPresupuesto = "";
      }
      if (this.mes_real_hasta === 13) {
        this.calculoReal = "Cálculo con datos Reales: Ninguno";
        this.calculoPresupuesto =
          "Cálculo con datos Presupuestados: Enero a Diciembre";
        return;
      }

      this.calculoReal =
        "Cálculo Real: Enero a " +
        this.enteroaMeses(this.mes_real_hasta, false);
      this.calculoPresupuesto =
        "Cálculo Presupuesto: " +
        this.enteroaMeses(this.mes_real_hasta + 1, false) +
        " a Diciembre";
    },
    mostrarVersionPresupuesto(tipo) {
      this.dialogVersionPresupuesto = true;
      if (tipo === "edit") {
        this.editVersion = true;
        this.mostrarDetalleVersion();
      } else {
        this.editVersion = false;
        this.generarCodigoVersion();
      }
    },
    closeVersionPresupuesto() {
      this.dialogVersionPresupuesto = false;
      this.codigoVersionPresupuesto = "";
      this.descripcionVersionPresupuesto = "";
      this.salarioMinimoVersionPresupuesto = 0;
      this.mes_real_hasta = "";
      this.es_oficial = false;
      this.otraVersion = false;
      this.calcularMesesRealesPresup();
    },
    mostrarDetalleVersion() {
      this.codigoVersionPresupuesto =
        this.versionPresupuestos[
          this.$obtenerIndicePorID(
            this.versionPresupuestos,
            this.id_version_presupuesto
          )
        ].cod;
      this.descripcionVersionPresupuesto =
        this.versionPresupuestos[
          this.$obtenerIndicePorID(
            this.versionPresupuestos,
            this.id_version_presupuesto
          )
        ].desc;
      this.salarioMinimoVersionPresupuesto =
        this.versionPresupuestos[
          this.$obtenerIndicePorID(
            this.versionPresupuestos,
            this.id_version_presupuesto
          )
        ].salario_minimo || 0;
      this.es_oficial =
        this.versionPresupuestos[
          this.$obtenerIndicePorID(
            this.versionPresupuestos,
            this.id_version_presupuesto
          )
        ].es_oficial;
      this.es_oficial =
        this.versionPresupuestos[
          this.$obtenerIndicePorID(
            this.versionPresupuestos,
            this.id_version_presupuesto
          )
        ].es_oficial;
      this.mes_real_hasta =
        this.versionPresupuestos[
          this.$obtenerIndicePorID(
            this.versionPresupuestos,
            this.id_version_presupuesto
          )
        ].mes_real_hasta;
      console.log(this.mes_real_hasta);
      this.calcularMesesRealesPresup();
    },
    modificarVersion() {
      this.id_version_presupuesto;
    },
    mostrarListaUniforme() {
      if (this.selectPersonas.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos una persona.",
          color: "error",
        });
        return;
      }
      if (this.validarPersona() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar el mes de inicio de cálculo.",
          color: "error",
        });
        return;
      }
      this.dialogUniformes = true;
    },
    

    generarSeguros() {
      //codigo para guardar
      if (this.selectPersonas.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos una persona.",
          color: "error",
        });
        return;
      }
      if (this.validarPersona() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar el mes de inicio de cálculo.",
          color: "error",
        });
        return;
      }
      let me = this;
      me.close();
      me.overlay = true;
      axios
        .post("api/presupuesto_lineas/CalcularSeguros", {
          id_presupuesto: me.id_presupuesto,
          id_version_presupuesto: me.id_version_presupuesto,
          tipo_presupuesto: me.tipo_presupuesto,
          persona: me.selectPersonas,
          mes: me.mesInicioCalculo,

          usuario: me.usuario,
        })
        .then(function (response) {
          me.dialogReplicar = false;
          me.overlay = false;
          me.listar();
          me.limpiar();
          me.$store.dispatch("setSnackbar", {
            text: "Cálculo de Subsidios para los empleados seleccionados realizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },





    // exportarExcel() {

    //   let me = this;
    //   axios
    //     .get("api/presupuesto_lineas/ListarPresupuestoNomExcel/" + me.id_presupuesto)
    //     .then(function (response) {
    //       me.presupuesto_lineas_excel = response.data;
    //       try {
    //         json2excel({
    //           data: me.presupuesto_lineas_excel,
    //           name: "DetallePresupuesto",
    //           formateDate: "yyyy/mm/dd",
    //         });
    //       } catch (e) {
    //         console.error(e);
    //       }

    //     })
    //     .catch(function (error) {
    //       me.$store.dispatch("setSnackbar", {
    //         text:
    //           error == "Error: Network Error"
    //             ? "No se pudo conectar con el servidor"
    //             : error,
    //         color: "error",
    //         timeout: 1000,
    //       });
    //     });
    // },

    mostrarPorcentajeInc() {
      if (this.selectPersonasIncremento.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos una persona.",
          color: "error",
        });
        return;
      }
      this.dialogPorcentaje = true;
    },
    exportarExcelPer() {
      let me = this;
      try {
        json2excel({
          data: me.personas,
          name: "Persona",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error(e);
      }
    },

    validar(formulario) {
      this.valida = 0;

      Object.keys(formulario).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },
    validarPersona() {
      this.valida = 0;

      Object.keys(this.formPersona).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },
    validarSubsidio() {
      this.valida = 0;

      Object.keys(this.formSubsidio).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },
    validarGrupoNomina() {
      this.valida = 0;

      Object.keys(this.formGrupoNomina).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/presupuesto_lineas/activar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/presupuesto_lineas/desactivar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    eliminarLineasPresupuesto() {
      let me = this;
      me.close();
      axios
        .post("api/presupuesto_lineas/EliminarLineasPresupuesto", {
          linea: me.selectDatosPresup,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.listar();
          me.limpiar();
          me.dialogEliminacion = false;
          me.closeDetallePresup();

          me.$store.dispatch("setSnackbar", {
            text: "Registros eliminados exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    eliminarPersonasPresupuesto() {
      let me = this;
      //me.close();
      me.loadBorrar = true;
      axios
        .post("api/presupuesto_lineas/EliminarPersonaPresupuesto", {
          id_version_presupuesto: me.id_version_presupuesto,
          linea: me.selectPersonaPresup,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.listar();
          me.limpiar();
          me.dialogEliminacionPersona = false;
          me.loadBorrar = false;
          me.boxEliminarPersonaPresupuesto = false;
          //me.closeDetallePresup();

          me.$store.dispatch("setSnackbar", {
            text: "Registros eliminados exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    cancelarEliminacionPersona() {
      this.dialogEliminacionPersona = false;
      this.boxEliminarPersonaPresupuesto = false;
    },

    generarCodigoVersion() {
      var siguiente = this.versionPresupuestos.length + 1;
      var zero = siguiente > 9 ? "" : "0";
      var num = zero + siguiente;
      this.codigoVersionPresupuesto = this.gestion + " - " + num;
    },

    sincronizarSalarios() {
      let me = this;

      axios
        .put("api/personas/sincronizarSalarios/" + me.usuario, {})
        .then(function (response) {
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
          me.listarPersona();
          me.listarPersonaIncremento();
          me.dialogSincronizarSueldos = false;
        })
        .catch(function (err) {
          me.mostrarErrores = true;
          me.$store.dispatch("setSnackbar", {
            text: err.response.data,
            color: "error",
          });
        });
    },

    formatoFechaSpanish(fecha) {
      var anio = fecha.substring(6, 6);
      var mes = fecha.substring(3, 2);
      var dia = fecha.substring(0, 2);
      if (fecha != "") {
        try {
          var m = new Date(fecha);
          var dateString =
            ("0" + m.getUTCDate()).slice(-2) +
            "-" +
            ("0" + (m.getUTCMonth() + 1)).slice(-2) +
            "-" +
            m.getUTCFullYear();
          return dateString;
        } catch (error) {
          console.error(error);
        }
      } else {
        return "";
      }
    },

    formatoFecha(fecha) {
      if (fecha == null) {
        return null;
      } else {
        if ((fecha != "") & (fecha != "0001-01-01T00:00:00")) {
          try {
            var m = new Date(fecha);
            var dateString =
              m.getUTCFullYear() +
              "-" +
              ("0" + (m.getUTCMonth() + 1)).slice(-2) +
              "-" +
              ("0" + m.getUTCDate()).slice(-2);
            return dateString;
          } catch (error) {
            console.error(error);
          }
        } else {
          return "";
        }
      }
    },

    //Devuelve un entero entre 1 y 12 convertido a mes en letras, si mayus=true -> se devuelven mayúsculas
    enteroaMeses(numeroMes, mayus) {
      var meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      var mesLetras = "";

      if (!isNaN(numeroMes) && numeroMes >= 1 && numeroMes <= 12) {
        mayus
          ? (mesLetras = meses[numeroMes - 1].toUpperCase())
          : (mesLetras = meses[numeroMes - 1]);
      }
      return mesLetras;
    },
    redondear(numero, decimales) {
      let number = numero;
      let arreglo = 10 ** decimales;
      let total = Math.round(arreglo * number) / arreglo;

      return total;
    },

    filtroCencoPer(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCencoPerValue) {
        return true;
      }
      // partially contains the searched word.
      if (value == "" || value == null) {
        return "";
      } else {
        return value
          .toLowerCase()
          .includes(this.searchCencoPerValue.toLowerCase());
      }
    },
    filtroAreaPer(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchAreaPerValue) {
        return true;
      }
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchAreaPerValue.toLowerCase());
    },
    filtroSubareaPer(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchSubareaPerValue) {
        return true;
      }
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchSubareaPerValue.toLowerCase());
    },
    filtroCargoPer(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCargoPerValue) {
        return true;
      }
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchCargoPerValue.toLowerCase());
    },
    filtroGrupoPer(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchGrupoPerValue) {
        return true;
      }
      // partially contains the searched word.
      if (value == "" || value == null) {
        return "";
      } else {
        return value
          .toLowerCase()
          .includes(this.searchGrupoPerValue.toLowerCase());
      }
    },

    filtroCuentaPresup(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCuentaPresupValue) {
        return true;
      }
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchCuentaPresupValue.toLowerCase());
    },

    filtroCencoPrespup(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCencoPresupValue) {
        return true;
      }
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchCencoPresupValue.toLowerCase());
    },
    filtroMesPresup(value) {
      var val = value.toString();
      var a = true;
      // If this filter has no value we just skip the entire filter.
      if (!this.searchMesValue) {
        return true;
      }
      //verificar si el mes completo se corresponde a la búsqueda
      value == this.searchMesValue ? (a = true) : (a = false);
      return a;
    },
    filtroSubcategoriaPrespup(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchSubcategoriaPresupValue) {
        return true;
      }
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchSubcategoriaPresupValue.toLowerCase());
    },
    filtroIncCargo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchPersIncCargo) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchPersIncCargo.toLowerCase());
    },

    filtroIncCenco(value) {
      // If this filter has no value we just skip the entire filter.

      if (!this.searchPersIncCenco) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      value = value == null ? "" : value;
      return value.includes(
        this.searchPersIncCenco == null ? "" : this.searchPersIncCenco
      );
    },

    filtroIncNombre(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchPersIncNombre) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchPersIncNombre.toLowerCase());
    },

    formatoNumero(n, d = 0) {
      return n.toLocaleString("es-CL", {
        minimumFractionDigits: d,
        maximumFractionDigits: d,
      });
    },
  },
};
</script>
<style scoped>
.v-overlay__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>